import {
  BanknotesIcon,
  BuildingOffice2Icon,
  ChevronDownIcon,
  ArrowTopRightOnSquareIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentListIcon,
  ShoppingCartIcon,
  MagnifyingGlassIcon,
  XMarkIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  EnvelopeOpenIcon,
  EnvelopeIcon,
  PencilSquareIcon,
  PhoneArrowUpRightIcon,
  PhoneIcon,
  PlusIcon,
  QuestionMarkCircleIcon,
  MapIcon,
  ArrowsRightLeftIcon,
  TrashIcon,
  UsersIcon,
  WrenchIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import {
  axiosWithToast,
  ChangedValues,
  ContactTitle,
  CustomerTitle,
  dateToString,
  dispatchWithToast,
  ItemStatus,
  mapErrors,
  NewLineFormatter,
  ProjectTitle,
  ReportTitle,
  safeString,
  searchFieldsByName,
  SeoHelmetWrapper,
  StringLimit,
} from "../../../components/Utils";
import { CopyToClipboard, TWclassNames } from "../../../components/utils/Div";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./case-view-redesign.css";
import {
  createCaseItem,
  deleteCaseItem,
  CASE_DETAIL_FIELDS_WITHOUT_ITEMS,
  fetchCase,
  fetchCaseItems,
  fetchCaseTypes,
  fetchSiblingOpenCases,
  updateCaseItem,
  caseWriteFailed,
  caseWriteErrorMessage,
} from "../../../api/case";
import { presentCaseAccessForbidden } from "./caseAccessFeedback";
import CaseTransferDialog from "../../../components/dashboard/cases/CaseTransferDialog";
import { CaseHeaderRelationTags } from "../../../components/dashboard/cases/CaseHeaderRelationTags";
import { CaseEmailExcerptCard } from "../../../components/dashboard/cases/CaseEmailExcerptCard";
import { CaseEmailNoticeChips } from "../../../components/dashboard/cases/CaseEmailNoticeChips";
import { CaseTimelineMailBody } from "../../../components/dashboard/cases/CaseTimelineMailBody";
import { CaseMailThreadDialog } from "../../../components/dashboard/cases/CaseMailThreadDialog";
import { CaseLinkMailThreadDialog } from "../../../components/dashboard/cases/CaseLinkMailThreadDialog";
import { CaseCustomerEmailDialog } from "../../../components/dashboard/cases/CaseCustomerEmailDialog";
import { CompanyAiMailboxMessageReaderDialog } from "../../../components/dashboard/microsoft/CompanyAiMailboxMessageReaderDialog";
import { createCaseGuideRun, fetchActiveCaseGuideTemplates, fetchCaseGuideTemplate } from "../../../api/caseGuides";
import { updateCustomerCommunication } from "../../../api/customer";
import { fetchUsers } from "../../../api/user";
import {
  createCaseAsync,
  deleteCaseAsync,
  updateCaseAsync,
} from "../../../slices/case";
import { PMButton } from "../../../components/utils/PMButton";
import { PMDialog } from "../../../components/utils/PMDialog";
import toast from "react-hot-toast";
import { CasePriorityStatus } from "../../../components/dashboard/cases/utils";
import { PMField } from "../../../components/utils/PMField";
import { PMDatePicker } from "../../../components/utils/PMDatePicker";
import { CustomerSelector } from "../../../components/utils/moduleSelectors/customerSelector";
import { ContactsSelector } from "../../../components/utils/moduleSelectors/contactSelector";
import { CustomerPicker, ContactPicker } from "../../../components/utils/pickers";
import ModernEmployeeSelector from "../../../components/utils/Selector/ModernEmployeeSelector";
import { priorityOptions } from "../../../components/dashboard/quality/deviations/utils";
import { DocumentViewer } from "../../../components/dashboard/Media/documentViewer";
import { useSelector } from "react-redux";
import ServiceReportEditModal from "../../../components/dashboard/service/reports/service-report-edit-modal";
import CustomerDialog from "../../../components/dashboard/customers/dialog";
import ServiceAgreementModal from "../../../components/dashboard/service/agreements/modal";
import SimplePrompt from "../../../components/utils/simplePrompt";
import { FieldDialog } from "../../../components/dashboard/inputFields/fieldDialog";
import PMDropdown from "../../../components/utils/PMDropdown";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Popover, Transition } from "@headlessui/react";
import { ReportSelector } from "../../../components/utils/moduleSelectors/reportSelector";
import { ProjectSelector } from "../../../components/utils/moduleSelectors/projectSelector";
import { EmployeeSelector } from "../../../components/utils/moduleSelectors/employeeSelector";
import { MentionTextEditor, extractMentionedUsers, CaseItemDescription } from "../../../components/utils/MentionTextEditor";
import { CaseTagSelector } from "../../../components/dashboard/cases/CaseTagSelector";
import { UnreadEmailTagBadge } from "../../../components/dashboard/cases/UnreadEmailTagBadge";
import {
  caseHasUnreadEmailTag,
  isEmailSummaryItem,
  rememberUnreadMailCleared,
  tagsIncludeUnreadEmail,
  unreadInboundMailItemIds,
} from "../../../components/dashboard/cases/unreadInboundMail";
import { DocumentUploadSectionV4 } from "../../../components/dashboard/Media/DocumentUploadSectionV4";
import { TemplateDialogButton } from "../../../components/dashboard/templates/template-dialog-button";
import CaseUpdateComposer from "../../../components/dashboard/cases/CaseUpdateComposer";
import { ResourceLoading } from "../../../components/utils/ResourceLoading";
import { TinyDocumentSection } from "../../../components/dashboard/documents/tinyDocumentSection";
import { ObjectRenderErrorBoundary } from "../../../components/utils/ObjectRenderErrorBoundary";
import { SaveBar } from "../../../components/utils/SaveBar";
import CaseGuideOnboardingDialog from "../../../components/dashboard/cases/guides/CaseGuideOnboardingDialog";
import CaseGuideSummaryCard from "../../../components/dashboard/cases/guides/CaseGuideSummaryCard";
import CaseCreateOnboardingDialog from "../../../components/dashboard/cases/guides/CaseCreateOnboardingDialog";
import CaseSummaryCard from "../../../components/dashboard/cases/CaseSummaryCard";
import CustomerSystemDialog from "../../../components/dashboard/customers/systems/system-dialog";
import { fetchCustomerSystems, updateSystem } from "../../../api/customer/system";
import { useUserHasAccess } from "../../../routes/roleOnly";

// Feltene i saks-skjemaet som avgjør om brukeren har gjort en ny endring mens en
// autolagring var underveis. Brukes til å oppdage «stale write»-kappløp.
const CASE_AUTOSAVE_SIGNATURE_KEYS = [
  "customer_id",
  "contact_id",
  "report_id",
  "project_id",
  "title",
  "description",
  "case_type_id",
  "user_responsible_id",
  "user_assigned_id",
  "note",
  "status",
  "priority",
  "due_date",
  "date",
  "tag_ids",
];

/** Stabil signatur av de redigerbare saksfeltene, for å sammenligne innsendte
 *  verdier mot gjeldende skjemaverdier (oppdager endringer gjort under lagring). */
function caseValuesSignature(values) {
  if (!values) return "";
  try {
    return JSON.stringify(
      CASE_AUTOSAVE_SIGNATURE_KEYS.reduce((acc, key) => {
        acc[key] = values[key] ?? null;
        return acc;
      }, {})
    );
  } catch {
    return "";
  }
}

export function TagsView({ tags, onDeleteTag = () => {} }) {
  const tagColor = (tag) => {
    switch (tag?.module) {
      case "report":
        return "bg-blue-100 text-blue-800";
      case "contact":
        return "bg-green-100 text-green-800";
      case "customer":
        return "bg-red-100 text-black";
      case "project":
        return "bg-yellow-100 text-yellow-800";
      case "user":
        return "bg-indigo-100 text-indigo-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const TagTitle = (tag) => {
    switch (tag?.module) {
      case "report":
        return <ReportTitle report={tag?.object} />;
      case "contact":
        return <ContactTitle contact={tag?.object} />;
      case "customer":
        return <CustomerTitle customer={tag?.object} useDialog={true} />;
      case "project":
        return <ProjectTitle project={tag?.object} />;
      case "user":
        return tag?.object?.displayTitle || tag?.object?.name || `@${tag?.module_param}`;
      default:
        return tag?.object?.displayTitle || tag?.module_param || tag?.module || "";
    }
  };

  return tags?.map((item, idx) => {
    return (
      <span
        key={item?.module + item?.module_param}
        className={TWclassNames(
          tagColor(item),
          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mr-2"
        )}
      >
        <span className="flex justify-between">
          <span>
            {(() => {
              const content = item?.id
                ? item?.object
                  ? TagTitle(item)
                  : item?.module_param
                : item?.object
                  ? item?.object?.displayTitle
                  : item?.module + " " + item?.module_param;
              return typeof content === "string" || typeof content === "number" || React.isValidElement(content)
                ? content
                : null;
            })()}
          </span>
          {!item?.id && (
            <button
              type="button"
              className="cursor-pointer"
              onClick={onDeleteTag(idx)}
            >
              <XCircleIcon className="h-5 w-5 ml-2" />
            </button>
          )}
        </span>
      </span>
    );
  });
}

export function CaseItemUpdate(props) {
  const { caseItem } = props;
  const { t } = useTranslation();

  const createItem = async (values) => {
    return await createCaseItem(values);
  };
  const [documents, setDocuments] = useState([]);

  const UploaderCallback = (data, formik) => {
    // Add documents to document state remove duplicates
    const newDocuments = [...documents, ...data];
    const uniqueDocuments = newDocuments.filter(
      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
    );
    setDocuments(uniqueDocuments);

    // Add documents to formik
    formik.setFieldValue("documents", [...documents, ...data]);

    setIsLoading(false);

    // Trigger document refresh in parent component
    if (props.onDocumentRefresh) {
      props.onDocumentRefresh();
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const [openModuleDialog, setOpenModuleDialog] = useState();

  const moduleAction = (type) => {
    setOpenModuleDialog(null);
    setTimeout(() => {
      setOpenModuleDialog(type);
    }, 25);
  };

  const handleModuleSelectorOnClose = (state) => {
    if (!state) {
      setOpenModuleDialog(null);
    }
  };

  const [tags, setTags] = useState([]);

  function TagSelector({ formik }) {
    const moduleTags = [
      { name: t("Report"), action: () => moduleAction("report") },
      { name: t("Contact"), action: () => moduleAction("contact") },
      { name: t("Customer"), action: () => moduleAction("customer") },
      { name: t("Project"), action: () => moduleAction("project") },
    ];

    const onModuleDialogSelectorChange = (type, e) => {
      const payload = {
        module: type,
        module_param: e?.target?.value,
        object: e?.target?.data?.object,
      };

      // add as tags
      // module + id
      setTags([...tags, payload]);

      setOpenModuleDialog(null);

      formik.setFieldValue("tags", [...tags, payload]);
    };

    return (
      <>
        <Popover className="relative">
          <Popover.Button className="inline-flex items-center gap-x-1 text-md px-2 leading-6 text-blue-400 hover:text-blue-600">
            <span>{t("Tags")}</span>
            <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
              <div className="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                {moduleTags.map((item) => (
                  <a
                    key={item.name}
                    onClick={item.action}
                    className="block p-2 hover:text-blue-400 cursor-pointer"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>

        <ContactsSelector
          showField={false}
          open={openModuleDialog === "contact"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("contact", data)}
        />

        <CustomerSelector
          showField={false}
          open={openModuleDialog === "customer"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("customer", data)}
        />

        <ReportSelector
          showField={false}
          open={openModuleDialog === "report"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("report", data)}
        />

        <ProjectSelector
          showField={false}
          open={openModuleDialog === "project"}
          onClose={(state) => handleModuleSelectorOnClose(state)}
          onChange={(data) => onModuleDialogSelectorChange("project", data)}
        />
      </>
    );
  }

  const handleDeleteTag = (idx, formik) => () => {
    const newTags = [...formik.values.tags];
    newTags.splice(idx, 1);
    formik.setFieldValue("tags", newTags);
    setTags(newTags);
  };

  const initialValues = {
    id: null,
    case_id: caseItem.id,
    dueDate: null,
    title: null,
    description: null,
    documents: null,
    tags: [],
    submit: null,
  };

  function NotifyEmployeeSelector(props) {
    const { setFieldValue } = props;

    const [open, setOpen] = useState(false);
    const [employee, setEmployee] = useState(null);

    useEffect(() => {
      if (setFieldValue && employee) {
        setFieldValue("notifyEmployee", employee);
      }
    }, [employee]);

    return (
      <>
        {employee ? (
          <>
            <div className="flex">
              <div className="flex flex-col ">
                <span className="italic text-xs w-[100px]">
                  Varsel sendes til
                </span>{" "}
                <span>
                  <StringLimit text={employee.displayTitle} />
                </span>
              </div>

              <PMButton
                styleType="minimal px-4"
                onClick={() => setEmployee(null)}
              >
                <XCircleIcon className="h-5 w-5 text-red-400" />
              </PMButton>
            </div>
          </>
        ) : (
          <PMButton onClick={() => setOpen(!open)}>
            {t("Notify Employee")}
          </PMButton>
        )}
        <EmployeeSelector
          showField={false}
          open={open}
          onClose={() => setOpen(false)}
          onChange={(data) => setEmployee(data.target.object)}
        />
      </>
    );
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={Yup.object({
        description: Yup.string().required(t("Description is required")),
      })}
      onSubmit={(values, helpers) => {
        try {
          const mentionedUsers = extractMentionedUsers(values.description || "");
          const userTags = mentionedUsers.map((u) => ({
            module: "user",
            module_param: u.id,
          }));
          const allTags = [...(values.tags || []), ...userTags];
          const notifyEmployee = mentionedUsers[0] ? { id: mentionedUsers[0].id } : values.notifyEmployee;
          axiosWithToast(
            createItem({ ...values, tags: allTags, notifyEmployee }),
            props.onChange
          );
          helpers.setStatus({ success: true });
          helpers.setSubmitting(false);
          helpers.setFieldValue("description", "");
          helpers.resetForm(initialValues);
          setTags([]);
        } catch (err) {
          toast.error("Something went wrong...");
          console.error(err);
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: err.message });
          helpers.setSubmitting(false);
        }
      }}
    >
      {(formik) => {
        return (
          <Form className="relative h-full shadow-smrounded-lg border border-gray-300 ">
            <div className="focus-within:border-blue-400 focus-within:ring-1 focus-within:ring-blue-400">
              <label htmlFor="description" className="sr-only">
                {t("Description")}
              </label>
              {!formik?.isSubmitting && (
                <div className="block mb-4">
                  <MentionTextEditor
                    name="description"
                    formik={formik}
                    placeholder={t("Write an update...")}
                    minHeight={120}
                    maxHeight={200}
                  />
                </div>
              )}
              {/* Tags section with proper spacing */}
              {formik?.values?.tags && (
                <div className="mt-3 mb-4">
                  <div className="px-2">
                    <TagsView
                      tags={formik.values.tags}
                      onDeleteTag={(idx) => handleDeleteTag(idx, formik)}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="block inset-x-px bottom-0 mt-4">
              <div className="flex items-center justify-between space-x-3 border-t border-gray-200 px-2 py-4 sm:px-3">
                <div className="flex">
                  <div className="">
                    <DocumentUploadSectionV4
                      iconOnly={true}
                      module="CASE"
                      module_param={caseItem.id}
                      parentCallback={(data) => UploaderCallback(data, formik)}
                    />
                  </div>
                  <div className="max-h-[20px] ">
                    <DocumentViewer
                      size="small"
                      pathType="url"
                      documents={formik?.values?.documents}
                      onChange={(data) => {
                        formik.setFieldValue("documents", data);
                      }}
                    />
                  </div>
                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <TagSelector formik={formik} />
                  </div>

                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <div className="ml-2">
                      <NotifyEmployeeSelector {...formik} />
                    </div>
                  </div>

                  <div className="ml-2 py-2 border-l-2 border-gay-50">
                    <div className="ml-2">
                      <TemplateDialogButton
                        fieldName="description"
                        {...formik}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <button
                    onClick={formik.submitForm}
                    type="button"
                    className="disabled:bg-gray-200 inline-flex items-center rounded-md bg-blue-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    disabled={formik?.isSubmitting}
                  >
                    {t("Create")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

/**
 * Isolated User Assigned field - resolves display from caseItem or userOptions.
 * Always derives strings for render; never passes objects that could cause React child errors.
 */
function CaseUserAssignedField({ userId, caseUserAssigned, userOptions, onChange, formik }) {
  const { t } = useTranslation();

  const displayLabel = (() => {
    if (!userId) return t("Velg ansatt");
    if (caseUserAssigned?.id == userId) {
      return safeString(caseUserAssigned?.displayTitle ?? caseUserAssigned?.name, t("Velg ansatt"));
    }
    const opt = userOptions?.find((u) => String(u?.value ?? u?.id) === String(userId));
    if (opt) return safeString(opt?.title ?? opt?.name, t("Velg ansatt"));
    return safeString(caseUserAssigned?.displayTitle ?? caseUserAssigned?.name, t("Velg ansatt"));
  })();

  const selectedForSelector = (() => {
    if (!userId) return [];
    const label = displayLabel !== t("Velg ansatt") ? displayLabel : "";
    return [{ id: userId, name: label, displayTitle: label }];
  })();

  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">{t("User Assigned")}</label>
      <Popover className="relative">
        <Popover.Button className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm shadow-sm hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500">
          <span className={userId ? "text-gray-900" : "text-gray-500"}>{displayLabel}</span>
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in duration-75"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Popover.Panel className="absolute left-0 right-0 top-full z-50 mt-1 overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            {({ close }) => (
              <div className="w-72 max-h-80">
                <ModernEmployeeSelector
                  open={true}
                  selectedEmployees={selectedForSelector}
                  onChange={(employees) => {
                    const emp = employees[0];
                    formik.setFieldValue("user_assigned_id", emp?.id ?? null);
                    close();
                  }}
                  onClose={close}
                  multiple={false}
                />
              </div>
            )}
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  );
}

function GuideTemplatePickerDialog({ open, templates, purpose, onClose, onSelect }) {
  const { t } = useTranslation();

  return (
    <PMDialog open={open} onClose={onClose} size="lg" title={t("Velg guide")}>
      <div className="space-y-3">
        <p className="text-sm text-gray-600">
          {purpose === "request_info"
            ? t("Velg hvilken guide du vil bruke for etterspurt info.")
            : t("Velg hvilken guide du vil starte for denne saken.")}
        </p>
        <div className="space-y-2">
          {(templates || []).map((template) => (
            <button
              key={template.id}
              type="button"
              onClick={() => onSelect(template)}
              className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-left transition hover:border-emerald-300 hover:bg-emerald-50"
            >
              <p className="text-sm font-medium text-gray-950">{template.title || t("Case guide")}</p>
              {template.description && (
                <p className="mt-1 line-clamp-2 text-xs text-gray-500">{template.description}</p>
              )}
              <p className="mt-2 text-xs text-gray-400">
                {(template.questions || []).length} {t("spørsmål")}
              </p>
            </button>
          ))}
        </div>
      </div>
    </PMDialog>
  );
}

export default function CaseView(props) {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const canCreateCase = useUserHasAccess({ role: "cases_create" });
  const canWriteCase = useUserHasAccess({
    roles: ["cases_write", "cases_edit"],
  });
  const canEditCase = useUserHasAccess({ role: "cases_edit" });
  const presentCaseForbidden = (code, messageKey) =>
    presentCaseAccessForbidden({
      code,
      message: t(messageKey),
      title: t("cases.access.forbidden_title"),
      saveLabel: t("cases.access.save_step"),
    });

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    caseItem: {},
  });

  const {
    open,
    onClose,
    selected,
    onEditing,
    customer,
    project,
    report,
    contact,
    onRefresh,
    title,
    itemTags,
  } = props;

  const { isLoading, error, errors, caseTypes, caseItem, users } = itemState;

  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [serviceAgreementDialogOpen, setServiceAgreementDialogOpen] =
    useState(false);

  const [userOptions, setUserOptions] = useState({
    isLoading: true,
    error: false,
    errors: [],
    data: [],
  });

  const [caseTypeOptions, setCaseTypeOptions] = useState({
    isLoading: true,
    error: false,
    errors: [],
    data: [],
  });

  const [caseItemsState, setCaseItemsState] = useState({
    isLoading: false,
    isLoadingMore: false,
    error: false,
    errors: [],
    data: [],
    page: 1,
    perPage: 20,
    totalCount: 0,
    hasMore: true,
  });
  const [openedWithUnreadMail, setOpenedWithUnreadMail] = useState(false);
  const caseContentScrollRef = useRef(null);
  const composerRef = useRef(null);
  // Track timeline fetch sequencing and activity to avoid stale overwrites and stuck loading
  const itemsRequestSeqRef = useRef(0);
  const itemsActiveRequestsRef = useRef(0);

  // Add state for expanded items
  const [expandedItems, setExpandedItems] = useState(new Set());

  // Mobile details drawer (desktop panel always visible; ≤860px uses slide-over)
  const [caseMenuOpen, setCaseMenuOpen] = useState(false);

  // Escape closes the mobile details drawer.
  useEffect(() => {
    if (!caseMenuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setCaseMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [caseMenuOpen]);

  const caseAvatarInitials = useCallback((name) => {
    const parts = String(name || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }, []);

  const caseAvatarColor = useCallback((name) => {
    const palette = ["#1B6FE0", "#0E7A5C", "#7A5AF0", "#C2710C", "#0B3A78", "#E11D48"];
    const str = String(name || "x");
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
    return palette[hash % palette.length];
  }, []);

  const caseStatusMeta = useMemo(() => {
    const raw = String(caseItem?.status || "").toUpperCase();
    const map = {
      NEW: { label: t("New"), className: "is-new" },
      PROCESSING: { label: t("Processing"), className: "is-processing" },
      FINISHED: { label: t("Finished"), className: "is-finished" },
      CLOSED: { label: t("Closed"), className: "is-closed" },
    };
    return map[raw] || { label: raw || t("Unknown"), className: "is-new" };
  }, [caseItem?.status, t]);

  const statusOptions = useMemo(
    () => [
      { value: "NEW", label: t("New"), dot: "#3b82f6", class: "bg-blue-50 text-blue-700" },
      { value: "PROCESSING", label: t("Processing"), dot: "#d97706", class: "bg-amber-50 text-amber-700" },
      { value: "FINISHED", label: t("Finished"), dot: "#16a34a", class: "bg-emerald-50 text-emerald-700" },
      { value: "CLOSED", label: t("Closed"), dot: "#64748b", class: "bg-slate-100 text-slate-700" },
    ],
    [t]
  );

  // Edit state for case items (only own items)
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingItemDraft, setEditingItemDraft] = useState({ title: "", description: "" });
  const [editingCommCaseItemId, setEditingCommCaseItemId] = useState(null);
  const [commCaseEditDraft, setCommCaseEditDraft] = useState({ subject: "", body_text: "" });
  const [savingCommCaseEdit, setSavingCommCaseEdit] = useState(false);

  // Auto-save state: blur + 1 sec = save
  const [saveState, setSaveState] = useState({ isSaving: false, isSuccess: false, isError: false, errorMessage: null });
  const saveTimeoutRef = useRef(null);
  // Sekvensteller for autolagringer: hver lagring får et løpenummer. Når et svar
  // kommer tilbake og et nyere lagringskall allerede er startet, regnes svaret som
  // utdatert og ignoreres — slik at en gammel lagrings suksess-payload ikke
  // overskriver nyere endringer brukeren rakk å gjøre (f.eks. bytte sakstype).
  const saveSeqRef = useRef(0);
  // Siste verdisignatur vi planla en autolagring for. Hindrer at verdi-vokteren
  // planlegger på nytt ved urelaterte re-renders (samme signatur) og dermed
  // «sulter» debouncen; kun en reell verdiendring planlegger på nytt.
  const lastAutosaveSigRef = useRef(null);
  const caseFormSidebarRef = useRef(null);
  const caseFormPanelRef = useRef(null);
  const formikRef = useRef(null);
  const [caseGuideState, setCaseGuideState] = useState({
    open: false,
    template: null,
    pendingRun: null,
    autostartedCaseTypeId: null,
    purpose: "onboarding",
  });
  const [guidePickerState, setGuidePickerState] = useState({
    open: false,
    templates: [],
    purpose: "onboarding",
  });
  const [createCaseDialogOpen, setCreateCaseDialogOpen] = useState(false);
  const [systemDialogOpen, setSystemDialogOpen] = useState(false);
  const [caseSystems, setCaseSystems] = useState([]);
  const [showCaseTypeDialog, setShowCaseTypeDialog] = useState(false);
  const [showPriorityDialog, setShowPriorityDialog] = useState(false);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [caseTypeSearch, setCaseTypeSearch] = useState("");
  const [pickedCustomer, setPickedCustomer] = useState(null);
  const [pickedContact, setPickedContact] = useState(null);

  const currentUser = useSelector((state) => state?.session?.currentUser || state?.auth?.user || state?.user?.user || null);
  const listCaseRow = useSelector((state) => {
    const rows = state?.cases?.data;
    if (!Array.isArray(rows) || !id) return null;
    return rows.find((row) => String(row.id) === String(id)) || null;
  });

  const filteredCaseTypeOptions = useMemo(() => {
    const q = caseTypeSearch.trim().toLowerCase();
    const list = Array.isArray(caseTypeOptions.data) ? caseTypeOptions.data : [];
    if (!q) return list;
    return list.filter((opt) =>
      String(opt.title || "")
        .toLowerCase()
        .includes(q)
    );
  }, [caseTypeSearch, caseTypeOptions.data]);

  const loadCaseSystems = useCallback(() => {
    const customerId = caseItem?.customer?.id;
    const currentCaseId = caseItem?.id;
    if (!customerId || !currentCaseId) {
      setCaseSystems([]);
      return;
    }
    fetchCustomerSystems(customerId, {
      fields:
        "id,system_m_name,serial_number,placement,description,other_comment,delivery_address,product,system_type,case_id",
    })
      .then((res) => {
        const payload = res?.data;
        const list = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : [];
        setCaseSystems(
          list.filter((row) => Number(row.case_id) === Number(currentCaseId))
        );
      })
      .catch(() => setCaseSystems([]));
  }, [caseItem?.customer?.id, caseItem?.id]);

  useEffect(() => {
    loadCaseSystems();
  }, [loadCaseSystems]);

  /**
   * Planlegger én debounced autolagring om ~1s. Deles av både focusout-lytteren og
   * verdi-vokteren (samme `saveTimeoutRef`), slik at det aldri finnes to ventende
   * timere → ingen dobbel POST. Ved utløsning re-sjekkes `dirty`/`isSubmitting` mot
   * live formik, så vi hopper over hvis skjemaet allerede er lagret eller en annen
   * lagring (f.eks. status/prioritet-dialogens `submitForm`) pågår.
   */
  const scheduleAutosave = () => {
    if (!canEditCase) return;
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(() => {
      saveTimeoutRef.current = null;
      const f = formikRef.current;
      if (f?.dirty && !f?.isSubmitting) f.submitForm();
    }, 1000);
  };

  /** Attaches focusout/focusin listeners for auto-save. Must be a component so useEffect is valid. */
  function CaseFormFocusListeners({ sidebarRef, panelRef, formikRef: fRef, caseId }) {
    useEffect(() => {
      if (!caseId) return;
      const sidebar = sidebarRef?.current;
      const panel = panelRef?.current;
      const handleFocusOut = (e) => {
        const inForm = sidebar?.contains(e.relatedTarget) || panel?.contains(e.relatedTarget);
        if (!inForm && fRef?.current?.dirty) {
          scheduleAutosave();
        }
      };
      const handleFocusIn = () => {
        if (saveTimeoutRef.current) {
          clearTimeout(saveTimeoutRef.current);
          saveTimeoutRef.current = null;
        }
      };
      sidebar?.addEventListener("focusout", handleFocusOut);
      sidebar?.addEventListener("focusin", handleFocusIn);
      panel?.addEventListener("focusout", handleFocusOut);
      panel?.addEventListener("focusin", handleFocusIn);
      return () => {
        sidebar?.removeEventListener("focusout", handleFocusOut);
        sidebar?.removeEventListener("focusin", handleFocusIn);
        panel?.removeEventListener("focusout", handleFocusOut);
        panel?.removeEventListener("focusin", handleFocusIn);
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs are stable, saveTimeoutRef is module-like
    }, [caseId]);
    return null;
  }

  /**
   * Verdi-basert autolagring. Enkelte kontroller (PMDatePicker for forfallsdato,
   * Sakstype-/Status-/Prioritet-dialoger i portaler, CaseTagSelector, saksbehandler)
   * endrer verdien via `setFieldValue` UTEN å produsere en `focusout` som forlater
   * sidebar/panel — derfor ble focusout-debouncen aldri planlagt og endringen ble
   * aldri lagret (kun «Du har ulagrede endringer»). Denne vokteren planlegger en
   * debounced lagring ~1s etter siste endring når skjemaet er `dirty` og ikke
   * allerede lagrer. Nøkkelen er en stabil signatur av de lagrede feltene, så den
   * fyrer kun på reelle brukerendringer — ikke ved mount/reinitialisering (skjemaet
   * er da pristine) og ikke i loop etter vellykket lagring (dirty nullstilles).
   */
  function CaseAutosaveWatcher({ formik, caseId }) {
    const signature = caseValuesSignature(formik?.values);
    const isDirty = !!formik?.dirty;
    const isSubmitting = !!formik?.isSubmitting;
    useEffect(() => {
      if (!caseId) return;
      // Pristine (mount/reinitialisering eller etter vellykket lagring/tilbakestilling):
      // ingen autolagring, og nullstill dedupe-vakten så neste reelle endring planlegges.
      if (!isDirty) {
        lastAutosaveSigRef.current = null;
        return;
      }
      if (isSubmitting) return;
      // Kun planlegg på nytt når signaturen faktisk har endret seg (reell endring),
      // ikke ved hver (u)relaterte re-render — ellers nullstilles debouncen konstant.
      if (lastAutosaveSigRef.current === signature) return;
      lastAutosaveSigRef.current = signature;
      scheduleAutosave();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- scheduleAutosave/formikRef/refs are stable
    }, [signature, isDirty, isSubmitting, caseId]);
    return null;
  }

  useEffect(() => () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
  }, []);

  // Function to toggle item expansion
  const toggleItemExpansion = (itemId) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  // Innhold vises alltid (ingen accordion-skjuling). Vi bruker kun en «Vis mer»-
  // klemme for ekstremt lange beskrivelser slik at feeden ikke drukner.
  const LONG_DESC_THRESHOLD = 600;

  const isItemLong = (item) => {
    const desc = typeof item?.description === "string" ? item.description.trim() : "";
    return desc.length > LONG_DESC_THRESHOLD;
  };

  // Function to check if item is expanded
  const isItemExpanded = (itemId) => {
    return expandedItems.has(itemId);
  };

  // User can only edit/delete their own items
  const canModifyItem = (item) =>
    item?.user?.id != null && currentUser?.id != null && Number(item.user.id) === Number(currentUser.id);

  const canEditOwnCustomerHandlerCommunication = (comm) => {
    if (!comm || currentUser?.id == null) return false;
    const meta = comm.metadata || {};
    return (
      meta.source === "customer_handler" &&
      Number(meta.handler_id) === Number(currentUser.id)
    );
  };

  const rightSideActions = [
    {
      label: "Service Report",
      description: "Create a service report",
      path: "",
      action: () => promptBeforeModuleDialog("report"),
      icon: Cog6ToothIcon,
      iconForeground: "text-teal-700",
      iconBackground: "bg-teal-50",
      completed: caseItem?.report?.id ? true : false,
      show: props.module === "service_report" ? false : true,
      active: true,
    },
    {
      label: "Service Agreement",
      description: "Create a service agreement",
      path: "",
      action: () => promptBeforeModuleDialog("service_agreement"),

      icon: UsersIcon,
      iconForeground: "text-purple-700",
      iconBackground: "bg-purple-50",
      completed: caseItem?.service_agreement?.id ? true : false,
      show: props.module === "service_agreement" ? false : true,
      active: true,
    },
    {
      label: "Project",
      description: "Create a project",
      path: "",
      action: () => promptBeforeModuleDialog("project"),

      icon: BuildingOffice2Icon,
      iconForeground: "text-sky-700",
      iconBackground: "bg-sky-50",
      completed: caseItem?.project?.id ? true : false,
      show: props.module === "project" ? false : true,
      active: true,
    },
    {
      label: "Order",
      description: "Create a order",
      path: "",
      action: () => promptBeforeModuleDialog("order"),
      icon: BanknotesIcon,
      iconForeground: "text-yellow-700",
      iconBackground: "bg-yellow-50",
      completed: caseItem?.order?.id ? true : false,
      show: props.module === "order" ? false : true,
      active: true,
    },
  ];

  async function fetchAndMapTypeOptions() {
    setCaseTypeOptions((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    // Fetch Case types from API?
    return fetchCaseTypes()
      .then((res) => {
        if (res.data) {
          var array = [];
          if (!res.data) return array;
          res?.data?.map((row, i) => {
            const rowParams = {
              value: row.id,
              title: row.title,
              order: i,
            };
            array.push(rowParams);
          });
          setCaseTypeOptions((prevState) => ({
            ...prevState,
            isLoading: false,
            data: array,
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        setCaseTypeOptions((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errors,
        }));
      });

    // Map into an array with ID and title?

    // Return the array
  }

  async function fetchAndMapUsers() {
    setUserOptions((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    // Fetch Case types from API?
    const controller = {
      filters: [{ name: "role", value: "case" }],
      page: 1,
      query: "",
      sort: "desc",
      sortBy: "id",
      view: "all",
      fields: "id,name,displayTitle",
    };

    await fetchUsers(controller)
      .then((res) => {
        if (res.data) {
          var array = [];
          if (!res.data) return array;
          res?.data?.map((row, i) => {
            const rowParams = {
              value: row.id,
              title: row.name,
              order: i,
            };
            array.push(rowParams);
          });
          setUserOptions((prevState) => ({
            ...prevState,
            isLoading: false,
            data: array,
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        setUserOptions((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errors,
        }));
      });

    // Map into an array with ID and title?

    // Return the array
  }

  const emptyObjToNull = (obj) =>
    obj && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length === 0 ? null : obj;

  const normalizeCaseItem = (item) => {
    if (!item) return item;
    return {
      ...item,
      project: emptyObjToNull(item.project),
      report: emptyObjToNull(item.report),
      service_agreement: emptyObjToNull(item.service_agreement),
      order: emptyObjToNull(item.order),
      contact: emptyObjToNull(item.contact),
      customer: emptyObjToNull(item.customer),
    };
  };

  const sortCaseItemsAsc = (items = []) => {
    return [...items].sort((a, b) => {
      const aDate = new Date(a?.created_at || 0).getTime();
      const bDate = new Date(b?.created_at || 0).getTime();
      if (aDate === bDate) return Number(a?.id || 0) - Number(b?.id || 0);
      return aDate - bDate;
    });
  };

  const scrollItemsToComposer = () => {
    requestAnimationFrame(() => {
      const el = caseContentScrollRef.current;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
      // Run one more time after layout settles (composer/timeline render race)
      setTimeout(() => {
        const settledEl = caseContentScrollRef.current;
        if (!settledEl) return;
        settledEl.scrollTop = settledEl.scrollHeight;
      }, 80);
    });
  };

  const fetchItemsPage = async (caseId, page, preserveScroll = false) => {
    if (!caseId) return;
    const scrollEl = caseContentScrollRef.current;
    const prevScrollTop = scrollEl?.scrollTop || 0;
    const prevScrollHeight = scrollEl?.scrollHeight || 0;

    // Increment request sequencing and active count
    const requestSeq = ++itemsRequestSeqRef.current;
    itemsActiveRequestsRef.current += 1;

    if (page === 1) {
      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: true,
        error: false,
        errors: [],
      }));
    } else {
      setCaseItemsState((prev) => ({
        ...prev,
        isLoadingMore: true,
        error: false,
        errors: [],
      }));
    }

    try {
      const result = await fetchCaseItems(caseId, {
        page,
        per_page: caseItemsState.perPage,
        sortBy: "created_at",
        sort: "desc",
      });

      // If the route `id` changed while this request was in-flight OR this is not the latest request, ignore.
      if (String(caseId) !== String(id) || requestSeq !== itemsRequestSeqRef.current) {
        return;
      }

      const incomingRaw = Array.isArray(result?.data) ? result.data : [];
      const incoming = sortCaseItemsAsc(incomingRaw);
      const totalCount = Number(result?.totalCount || 0);
      const currentCount = Number(result?.currentCount || incomingRaw.length);
      const hasMore = totalCount > page * caseItemsState.perPage && currentCount > 0;

      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: false,
        isLoadingMore: false,
        data: page === 1 ? incoming : [...incoming, ...prev.data],
        page,
        totalCount,
        hasMore,
      }));

      requestAnimationFrame(() => {
        const el = caseContentScrollRef.current;
        if (!el) return;

        if (page === 1) {
          // Show newest first by anchoring to composer at the bottom.
          scrollItemsToComposer();
          return;
        }

        if (preserveScroll) {
          const nextScrollHeight = el.scrollHeight;
          el.scrollTop = nextScrollHeight - prevScrollHeight + prevScrollTop;
        }
      });
    } catch (err) {
      // Ignore errors from stale/superseded requests (when navigating between cases quickly).
      if (String(caseId) !== String(id) || requestSeq !== itemsRequestSeqRef.current) {
        return;
      }
      setCaseItemsState((prev) => ({
        ...prev,
        isLoading: false,
        isLoadingMore: false,
        error: true,
        errors: [t("Could not load case items")],
      }));
    } finally {
      // Decrement active counter; if no active requests remain, ensure loading flags are cleared
      itemsActiveRequestsRef.current = Math.max(0, itemsActiveRequestsRef.current - 1);
      if (itemsActiveRequestsRef.current === 0) {
        setCaseItemsState((prev) => ({
          ...prev,
          isLoading: false,
          isLoadingMore: false,
        }));
      }
    }
  };

  const loadOlderCaseItems = async () => {
    // Use the current route id instead of the (possibly stale) caseItem.id
    if (!id) return;
    if (caseItemsState.isLoadingMore || caseItemsState.isLoading || !caseItemsState.hasMore) return;
    await fetchItemsPage(id, caseItemsState.page + 1, true);
  };

  const handleCaseItemsScroll = (e) => {
    if (!caseItemsState.hasMore || caseItemsState.isLoadingMore || caseItemsState.isLoading) return;
    if (e.currentTarget.scrollTop <= 120) {
      loadOlderCaseItems();
    }
  };

  // Mobile page-scroll fallback: when the feed itself isn't a scrollport,
  // load older items as the user reaches the top of the document.
  useEffect(() => {
    if (!caseItem?.id) return undefined;
    const onWindowScroll = () => {
      if (!caseItemsState.hasMore || caseItemsState.isLoadingMore || caseItemsState.isLoading) return;
      const feedEl = caseContentScrollRef.current;
      const feedIsScrollPort =
        !!feedEl && feedEl.scrollHeight > feedEl.clientHeight + 8;
      if (feedIsScrollPort) return;
      if (window.scrollY <= 120) {
        loadOlderCaseItems();
      }
    };
    window.addEventListener("scroll", onWindowScroll, { passive: true });
    return () => window.removeEventListener("scroll", onWindowScroll);
  }, [
    caseItem?.id,
    caseItemsState.hasMore,
    caseItemsState.isLoadingMore,
    caseItemsState.isLoading,
    caseItemsState.page,
  ]);

  const getCase = async () => {
    await fetchCase(id, { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS })
      .then((res) => {
        // A successful case fetch always includes an `id`. fetchCase swallows HTTP
        // errors and resolves with the error body, so a missing id here means the
        // load failed — surface the error/retry screen instead of silently falling
        // through to the "new case" create form (which is misleading for an existing
        // case that simply failed to load).
        if (!res?.id) {
          let errorList = [];
          const serverErrors = res?.errors;
          if (Array.isArray(serverErrors)) {
            errorList = serverErrors.filter((e) => typeof e === "string");
          } else if (serverErrors && typeof serverErrors === "object") {
            const mapped = mapErrors(serverErrors);
            if (mapped) errorList = [mapped];
          }
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            caseItem: {},
            error: true,
            errors: errorList,
          }));
          return;
        }
        // Set immediately (no artificial delay) so the case detail renders as soon as the
        // request resolves; the timeline items are fetched in parallel (see the id-keyed effect).
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          caseItem: normalizeCaseItem(res),
          // Clear any earlier load error so a successful retry restores the case view.
          error: false,
          errors: null,
        }));
      })
      .catch(() => {
        setItemState((prevState) => ({
          ...prevState,
          // Must clear the spinner on a thrown fetch error (e.g. network/timeout,
          // where fetchCase rejects instead of resolving with an error body).
          // Otherwise isLoading stays true forever and the page is stuck on the
          // loading state with no recovery. The error/retry screen is rendered from
          // `error` below.
          isLoading: false,
          caseItem: {},
          error: true,
          errors: [],
        }));
      });
  };

  // Re-run the case detail load after a failure (used by the error/retry screen).
  const retryLoadCase = () => {
    if (!id) return;
    setItemState((prevState) => ({
      ...prevState,
      isLoading: true,
      error: false,
      errors: [],
    }));
    getCase();
  };

  const createOrUpdateDispatch = (data) => {
    // onEditing(false);
    if (caseItem?.id) {
      const res = dispatch(updateCaseAsync(data));
      return res;
    } else {
      const res = dispatch(createCaseAsync(data));
      return res;
    }
  };

  const openCaseGuide = async (caseTypeId, purpose = "onboarding") => {
    if (!caseTypeId) {
      toast.error(t("Select case type first"));
      return;
    }

    const templates = await fetchActiveCaseGuideTemplates(caseTypeId, purpose === "request_info" ? "onboarding" : purpose);
    if (!templates?.length) {
      toast.error(t("No guide configured for this case type"));
      return;
    }

    if (templates.length > 1) {
      setGuidePickerState({ open: true, templates, purpose });
      return;
    }

    openGuideTemplate(templates[0], purpose);
  };

  const openGuideTemplate = (template, purpose = "onboarding") => {
    setCaseGuideState((prev) => ({
      ...prev,
      open: true,
      template,
      purpose,
    }));
  };

  const chainNextGuideIfNeeded = useCallback(async (caseId, guideResponse, purpose) => {
    const runPayload = guideResponse?.data;
    const nextId = runPayload?.effects_applied?.next_case_guide_template_id;
    if (!caseId || !nextId) return false;
    const full = await fetchCaseGuideTemplate(nextId);
    if (!full?.id) return false;
    setCaseGuideState((prev) => ({
      ...prev,
      open: true,
      template: full,
      purpose: purpose || prev.purpose || "onboarding",
      pendingRun: null,
    }));
    toast.success(t("guide.case_chain_started"));
    return true;
  }, [t]);

  const applyGuideEffectsToFormik = (effects) => {
    const formik = formikRef.current;
    if (!formik || !effects) return;

    if (effects.tag_ids?.length) {
      const currentIds = formik.values.tag_ids || [];
      formik.setFieldValue("tag_ids", [...new Set([...currentIds, ...effects.tag_ids])]);
    }
    if (effects.priority) formik.setFieldValue("priority", effects.priority.toString());
    if (effects.title_suffix && formik.values.title) {
      formik.setFieldValue("title", `${formik.values.title} ${effects.title_suffix}`.trim());
    }
  };

  const handleGuideComplete = async (guideRun) => {
    if (!caseItem?.id) {
      applyGuideEffectsToFormik(guideRun.effects);
      setCaseGuideState((prev) => ({
        ...prev,
        open: false,
        pendingRun: guideRun,
      }));
      return;
    }

    const response = await createCaseGuideRun(
      caseItem.id,
      {
        case_guide_template_id: guideRun.case_guide_template_id,
        purpose: guideRun.purpose,
        answers: guideRun.answers,
        requested_from_customer: guideRun.purpose === "request_info",
      },
      { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS }
    );

    if (response?.errors) {
      toast.error(Array.isArray(response.errors) ? response.errors.join(", ") : String(response.errors));
      return;
    }

    if (response?.case) {
      setItemState((prevState) => ({
        ...prevState,
        caseItem: normalizeCaseItem(response.case) ?? response.case,
      }));
    }
    await fetchItemsPage(caseItem.id, 1, false);

    const chained = await chainNextGuideIfNeeded(caseItem.id, response, guideRun.purpose);
    if (!chained) {
      setCaseGuideState((prev) => ({ ...prev, open: false, pendingRun: null }));
    }
  };

  function PostCreateGuidePrompt() {
    useEffect(() => {
      let cancelled = false;
      async function maybeOpenGuide() {
        const shouldOpenGuide = searchParams.get("openGuide") === "1";
        const caseTypeId = caseItem?.case_type?.id || caseItem?.case_type_id;
        const autostartKey = caseItem?.id ? `case_${caseItem.id}` : null;
        if (!shouldOpenGuide || !caseItem?.id || !caseTypeId || caseGuideState.autostartedCaseTypeId === autostartKey) return;

        const templates = await fetchActiveCaseGuideTemplates(caseTypeId, "onboarding");
        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete("openGuide");
        if (!cancelled) setSearchParams(nextParams, { replace: true });
        if (cancelled || !templates?.length) return;

        if (templates.length > 1) {
          setGuidePickerState({ open: true, templates, purpose: "onboarding" });
          setCaseGuideState((prev) => ({
            ...prev,
            autostartedCaseTypeId: autostartKey,
          }));
          return;
        }

        setCaseGuideState((prev) => ({
          ...prev,
          open: true,
          template: templates[0],
          purpose: "onboarding",
          autostartedCaseTypeId: autostartKey,
        }));
      }
      maybeOpenGuide();
      return () => {
        cancelled = true;
      };
    }, [caseItem?.id, caseItem?.case_type?.id, caseItem?.case_type_id, searchParams]);

    return null;
  }

  useEffect(() => {
    setCurrentTab(0);
    fetchAndMapTypeOptions();
    fetchAndMapUsers();
  }, [open]);

  useEffect(() => {
    setItemState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    setOpenedWithUnreadMail(false);
    if (id) {
      getCase();
    } else {
      setItemState((prevState) => ({
        ...prevState,
        isLoading: false,
        caseItem: {},
        error: false,
        errors: null,
      }));
    }
  }, [id, dispatch]);

  // Load the timeline items in parallel with the case detail. Both requests only need the
  // URL `id`, so keying this off `id` (instead of `caseItem?.id`, which is set only after the
  // case request resolves) removes the request waterfall that made opening a case feel slow and
  // left the timeline empty until the case finished loading.
  useEffect(() => {
    // Immediately clear previous timeline items on case switch to avoid stale display
    setCaseItemsState((prev) => ({
      ...prev,
      data: [],
      page: 1,
      totalCount: 0,
      hasMore: true,
      error: false,
      errors: [],
      isLoading: !!id,
      isLoadingMore: false,
    }));
    if (!id) {
      return;
    }
    fetchItemsPage(id, 1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchItemsPage reads only stable refs/state; re-run only when the case id changes
  }, [id]);

  useEffect(() => {
    setOpenedWithUnreadMail(false);
  }, [id]);

  // GET /cases/:id already clears Ulest svar fra kunde. Capture unread from the list
  // row (GET response no longer includes the tag) so the inbound card can glow.
  useEffect(() => {
    if (!caseItem?.id || String(caseItem.id) !== String(id)) return;
    if (tagsIncludeUnreadEmail(listCaseRow) || tagsIncludeUnreadEmail(caseItem)) {
      setOpenedWithUnreadMail(true);
      rememberUnreadMailCleared(caseItem.id);
    }
  }, [caseItem?.id, id, listCaseRow]);

  const unreadMailHighlightIds = useMemo(
    () =>
      new Set(
        unreadInboundMailItemIds(caseItemsState.data, {
          caseHasUnreadTag: caseHasUnreadEmailTag(caseItem),
          openedWithUnread: openedWithUnreadMail,
        })
      ),
    [caseItemsState.data, caseItem, openedWithUnreadMail]
  );

  // Prevent main page scroll - only items should scroll. Stick case container to viewport.
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    if (!isLoading && caseItem?.id) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = prevOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, [isLoading, caseItem?.id]);

  /**
   * itemActivityLabel — bygger den oversettbare aktivitetslinjen (predikatet)
   * som vises etter den (separat stylede) brukeren i feeden, f.eks.
   * «<b>Bruker</b> la til en rapport i saken». Vi slår opp en i18n-nøkkel per
   * `action` × `module`, med fallback til handlingens standard og til slutt en
   * generisk standard, slik at ingen kombinasjon viser rå nøkkel eller engelsk.
   * i18next sin nøkkel-array-fallback velger første som finnes; den siste
   * (`case.feed.activity._default`) finnes alltid.
   */

  const itemActivityLabel = (item) => {
    const action = item?.action;
    const moduleName = item?.module;

    if (moduleName === "case_guide_run") {
      return item?.module_object?.purpose === "request_info"
        ? t("case.feed.activity.case_guide_run.request_info")
        : t("case.feed.activity.case_guide_run.completed");
    }

    const base = "case.feed.activity";
    const keys = [];
    if (action && moduleName) keys.push(`${base}.${action}.${moduleName}`);
    if (action) keys.push(`${base}.${action}._default`);
    keys.push(`${base}._default`);

    // i18next velger første nøkkel som finnes; siste finnes alltid.
    return t(keys);
  };

  /**
   * CaseModuleLinkCard — én felles, alltid synlig kort-visning for moduler
   * tilknyttet en case-oppdatering (rapport, e-post, SMS, telefon, ordre,
   * avtale, prosjekt, kunde, notat …). Samme visuelle språk som designets
   * e-post-chip (radius 10px, border #E5E9F0, blått ikon). Skjules aldri.
   */
  const CaseModuleLinkCard = ({
    icon,
    type,
    title,
    meta,
    to,
    linkLabel,
    tone = "default",
    children,
  }) => {
    const Icon = icon;
    return (
      <div className={TWclassNames("cv-module-card", tone !== "default" && `is-${tone}`)}>
        <div className="cv-module-card-icon" aria-hidden="true">
          {Icon ? <Icon className="h-4 w-4" /> : null}
        </div>
        <div className="cv-module-card-body">
          {type ? (
            <div className="cv-module-card-type">{safeString(type)}</div>
          ) : null}
          {safeString(title) ? (
            <div className="cv-module-card-title">{safeString(title)}</div>
          ) : null}
          {safeString(meta) ? (
            <div className="cv-module-card-meta">{safeString(meta)}</div>
          ) : null}
          {children}
        </div>
        {to && (
          <Link to={to} className="cv-module-card-link">
            {safeString(linkLabel) || t("Åpne")}
            <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" />
          </Link>
        )}
      </div>
    );
  };

  const formatCallDuration = (seconds) => {
    if (seconds == null) return null;
    const m = Math.floor(seconds / 60);
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const displayModuleContent = (item) => {
    const { module } = item;
    switch (module) {
      case "case": {
        const linked = item?.module_object;
        if (linked?.id) {
          return (
            <CaseModuleLinkCard
              icon={ClipboardDocumentListIcon}
              type={t("Sak")}
              title={linked.displayTitle || `SAK-${linked.case_number}`}
              meta={linked.status}
              to={"/dashboard/cases/" + linked.id}
              linkLabel={t("Åpne")}
            />
          );
        }
        return undefined;
      }
      case "case_guide_run":
        if (item?.module_object?.id) {
          return <CaseGuideSummaryCard run={item.module_object} />;
        }
        return undefined;
      case "customer":
        if (item?.customer?.id && item?.customer?.displayTitle) {
          return (
            <CaseModuleLinkCard
              icon={BuildingOffice2Icon}
              type={t("Kunde")}
              title={item?.customer?.displayTitle}
              to={"/dashboard/customers/" + item?.customer?.id}
            />
          );
        }
        return undefined;
      case "project":
        if (item?.project?.id && item?.project?.displayTitle) {
          return (
            <CaseModuleLinkCard
              icon={ClipboardDocumentListIcon}
              type={t("Prosjekt")}
              title={item?.project?.displayTitle}
              to={"/dashboard/projects/" + item?.project?.id}
            />
          );
        }
        return undefined;
      case "service_agreement":
        if (
          item?.service_agreement?.id &&
          item?.service_agreement?.agreement_number
        ) {
          return (
            <CaseModuleLinkCard
              icon={ClipboardDocumentListIcon}
              type={t("Serviceavtale")}
              title={t("Avtale") + " #" + item?.service_agreement?.agreement_number}
              to={"/dashboard/service/agreements/" + item?.service_agreement?.id}
            />
          );
        }
        return undefined;
      case "order":
        if (item?.order?.id && item?.order?.order_number) {
          return (
            <CaseModuleLinkCard
              icon={ShoppingCartIcon}
              type={t("Ordre")}
              title={t("Ordre") + " #" + item?.order?.order_number}
              to={"/dashboard/orders/" + item?.order?.id}
            />
          );
        }
        return undefined;
      case "report":
        if (item?.report?.id) {
          return (
            <CaseModuleLinkCard
              icon={WrenchIcon}
              type={t("Servicerapport")}
              title={
                item?.report?.report_number
                  ? t("Rapport") + " #" + item?.report?.report_number
                  : t("Servicerapport")
              }
              to={"/dashboard/service/reports/" + item?.report?.id}
            />
          );
        }
        return undefined;
      case "note":
        if (item?.module_object?.note) {
          return (
            <CaseModuleLinkCard
              icon={DocumentTextIcon}
              type={t("Notat")}
              meta={item?.module_object?.note}
            />
          );
        }
        return undefined;
      case "phone":
        if (
          item?.module_object?.from_number ||
          item?.module_object?.to_number ||
          item?.module_object?.duration
        ) {
          const mo = item.module_object;
          const dur = formatCallDuration(mo?.duration);
          const numbers =
            mo?.from_number && mo?.to_number
              ? `${mo.from_number} → ${mo.to_number}`
              : mo?.from_number || mo?.to_number || null;
          return (
            <CaseModuleLinkCard
              icon={PhoneArrowUpRightIcon}
              type={t("Phone Call")}
              title={numbers}
            >
              <div className="cv-module-card-facts">
                {dur && (
                  <span>
                    {t("duration")} {dur}
                  </span>
                )}
                <span>
                  {t("status")} <ItemStatus item={mo} />
                </span>
                {mo?.reason && <span>{mo.reason}</span>}
              </div>
            </CaseModuleLinkCard>
          );
        }
        return undefined;
      case "weply": {
        const lead = item?.module_object && typeof item.module_object === "object" ? item.module_object : {};
        const name = lead.name || item?.title;
        const message = lead.message || item?.description;
        const customerId = caseItem?.customer?.id;
        return (
          <CaseModuleLinkCard
            icon={ChatBubbleLeftRightIcon}
            type={`${t("cases.weply.type")} · ${t("inbound")}`}
            title={name || t("cases.weply.type")}
            meta={lead.company_name || null}
            tone="weply"
            to={customerId ? `/dashboard/customers/${customerId}` : undefined}
            linkLabel={caseItem?.customer?.displayTitle}
          >
            {(lead.email || lead.phone || lead.session_id) && (
              <div className="cv-module-card-facts">
                {lead.email && <span>{lead.email}</span>}
                {lead.phone && <span>{lead.phone}</span>}
                {lead.session_id && (
                  <span>
                    {t("cases.weply.session")}: {lead.session_id}
                  </span>
                )}
              </div>
            )}
            {safeString(message) ? (
              <div className="cv-module-card-quote">{safeString(message)}</div>
            ) : null}
            {lead.fields && typeof lead.fields === "object" && Object.keys(lead.fields).length > 0 && (
              <div className="cv-module-card-extra-fields">
                <div className="cv-module-card-extra-title">{t("cases.weply.other_fields")}</div>
                {Object.entries(lead.fields).map(([fieldName, fieldValue]) => (
                  <div key={fieldName} className="cv-module-card-extra-row">
                    <span>{fieldName}</span>
                    <span>{String(fieldValue)}</span>
                  </div>
                ))}
              </div>
            )}
          </CaseModuleLinkCard>
        );
      }
      case "customer_communication":
        if (item?.module_object?.id) {
          const comm = item.module_object;
          const isSms = comm.channel === "sms";
          const channelIcon =
            comm.channel === "phone"
              ? PhoneIcon
              : isSms
              ? ChatBubbleLeftRightIcon
              : EnvelopeOpenIcon;
          const channelLabel =
            comm.channel === "phone"
              ? t("Telefon")
              : isSms
              ? t("SMS")
              : t("E-post");
          const directionLabel =
            comm.direction === "inbound" ? t("inbound") : t("outbound");
          return (
            <CaseModuleLinkCard
              icon={channelIcon}
              type={`${channelLabel} · ${directionLabel}`}
              title={comm.subject || channelLabel}
              meta={
                comm.sent_at
                  ? new Date(comm.sent_at).toLocaleString("nb-NO")
                  : null
              }
              to={comm.customer?.id ? `/dashboard/customers/${comm.customer.id}` : undefined}
              linkLabel={comm.customer?.displayTitle}
            >
              {isSms || comm.channel === "phone" ? (
                safeString(comm.body_text) ? (
                  <div className="cv-module-card-quote">{safeString(comm.body_text)}</div>
                ) : null
              ) : (
                <CaseTimelineMailBody
                  comm={comm}
                  mailboxId={caseItem?.mail_thread?.mailbox_id}
                  onOpenThread={() => setMailThreadOpen(true)}
                />
              )}
            </CaseModuleLinkCard>
          );
        }
        return undefined;
      default:
        return undefined;
    }
  };

  /**
   * caseLinkedModuleCards — utleder hvilke moduler som er knyttet direkte til
   * saken (kunde, kontakt, prosjekt, rapport, serviceavtale, ordre) og
   * gjenbruker `displayModuleContent` slik at kortene ser identiske ut med
   * modulkortene i feeden. Returnerer en liste av { key, node }.
   */
  const caseLinkedModuleCards = () => {
    if (!caseItem) return [];
    const entries = [];
    if (caseItem.customer?.id && caseItem.customer?.displayTitle) {
      entries.push({
        key: "customer",
        node: displayModuleContent({ module: "customer", customer: caseItem.customer }),
      });
    }
    if (caseItem.contact?.id) {
      entries.push({
        key: "contact",
        node: (
          <CaseModuleLinkCard
            icon={UsersIcon}
            type={t("Kontakt")}
            title={safeString(
              caseItem.contact?.displayTitle ?? caseItem.contact?.name
            )}
            to={
              caseItem.customer?.id
                ? "/dashboard/customers/" + caseItem.customer.id
                : undefined
            }
          />
        ),
      });
    }
    if (caseItem.project?.id && caseItem.project?.displayTitle) {
      entries.push({
        key: "project",
        node: displayModuleContent({ module: "project", project: caseItem.project }),
      });
    }
    if (caseItem.report?.id) {
      entries.push({
        key: "report",
        node: displayModuleContent({ module: "report", report: caseItem.report }),
      });
    }
    if (
      caseItem.service_agreement?.id &&
      caseItem.service_agreement?.agreement_number
    ) {
      entries.push({
        key: "service_agreement",
        node: displayModuleContent({
          module: "service_agreement",
          service_agreement: caseItem.service_agreement,
        }),
      });
    }
    if (caseItem.order?.id && caseItem.order?.order_number) {
      entries.push({
        key: "order",
        node: displayModuleContent({ module: "order", order: caseItem.order }),
      });
    }
    const systems = caseSystems.length
      ? caseSystems
      : [caseItem.system, caseItem.customer_system].filter((s) => s?.id);
    systems.forEach((system) => {
      entries.push({
        key: `system-${system.id}`,
        node: (
          <CaseModuleLinkCard
            icon={WrenchIcon}
            type={t("customer.systems.tab")}
            title={
              system.system_m_name ||
              system.product?.title ||
              system.serial_number ||
              t("System")
            }
            meta={system.description || system.other_comment || system.placement}
          />
        ),
      });
    });
    const linkedEmails = Array.isArray(caseItem.linked_emails)
      ? caseItem.linked_emails
      : [];
    linkedEmails.forEach((comm) => {
      if (!comm?.id) return;
      entries.push({
        key: `email-${comm.id}`,
        node: (
          <CaseEmailExcerptCard
            comm={comm}
            onOpenThread={() => setMailThreadOpen(true)}
            onOpenMessage={(row) => {
              if (row?.graph_message_id && caseItem?.mail_thread?.mailbox_id) {
                setMailReader({
                  graph_message_id: row.graph_message_id,
                  subject: row.subject,
                });
              } else {
                setMailThreadOpen(true);
              }
            }}
          />
        ),
      });
    });
    return entries.filter((e) => e.node);
  };

  function caseModulesTab() {
    const cards = caseLinkedModuleCards();
    return (
      <div className="cv-modules-tab">
        {cards.length === 0 ? (
          <div className="cv-fields-empty">{t("Ingen tilknyttede moduler")}</div>
        ) : (
          <div className="cv-modules-list">
            {cards.map((c) => (
              <div key={c.key}>{c.node}</div>
            ))}
          </div>
        )}
        {caseItem?.customer?.id ? (
          <button
            type="button"
            className="mt-4 rounded-lg border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            onClick={() => setSystemDialogOpen(true)}
          >
            {t("customer.systems.add_from_case")}
          </button>
        ) : null}
      </div>
    );
  }

  const tabs = [
    { name: t("Detaljer"), href: "#", current: true },
    { name: t("Moduler"), href: "#", current: false },
    { name: t("Felter"), href: "#", current: false },
    { name: t("Dokumenter"), href: "#", current: false },
  ];

  const [currentTab, setCurrentTab] = useState(0);

  const [customerDialogOpen, setCustomerDialogOpen] = useState(false);

  function caseTabs() {
    return (
      <div className="cv-panel-tabs" role="tablist" aria-label={t("Saksdetaljer")}>
        {tabs.map((tab, index) => (
          <button
            key={tab.name}
            type="button"
            role="tab"
            aria-selected={index === currentTab}
            onClick={() => setCurrentTab(index)}
            className={TWclassNames("cv-panel-tab", index === currentTab && "is-active")}
          >
            {tab.name}
          </button>
        ))}
      </div>
    );
  }

  const [fieldDialogOpen, setFieldDialogOpen] = useState(false);

  function caseFields() {
    const fields = Array.isArray(caseItem?.fields) ? caseItem.fields : [];
    return (
      <div className="cv-fields-tab">
        <div className="cv-fields-tab-head">
          <span className="cv-fields-tab-title">{t("Egendefinerte felter")}</span>
          <button
            type="button"
            className="cv-add-field-btn"
            onClick={() => setFieldDialogOpen(true)}
          >
            <PlusIcon className="h-4 w-4" />
            {t("Legg til felt")}
          </button>
        </div>

        {fields.length === 0 ? (
          <div className="cv-fields-empty">{t("Ingen felter ennå")}</div>
        ) : (
          <div className="cv-field-rows">
            {fields.map((field) => (
              <div key={field.name} className="cv-field-row">
                <span className="cv-field-row-label">{field.name}</span>
                <span className="cv-field-row-value">
                  <CopyToClipboard>
                    {typeof field.value === "string" || typeof field.value === "number"
                      ? String(field.value)
                      : ""}
                  </CopyToClipboard>
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  const handleDescriptionItemChange = (e, formik) => {
    const { name, value } = e.target;
    const items = [...formik.values.items];
    items[0].description = value;
    if (itemTags) {
      items[0].tags = itemTags;
    }
    formik.setFieldValue("items", items);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [removeCaseItemPromptOpen, setRemoveCaseItemPromptOpen] =
    useState(false);

  const handleDeleteItem = (id) => {
    setSelectedItem(id);
    setRemoveCaseItemPromptOpen(true);
  };

  const removeCaseItem = () => {
    deleteCaseItem({ case_id: caseItem?.id, id: selectedItem })
      .then((res) => {
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.filter((item) => item.id !== selectedItem),
          totalCount: Math.max(0, prev.totalCount - 1),
        }));

        setRemoveCaseItemPromptOpen(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Could not delete item"));
      });
  };

  const handleSaveCustomerCommunicationCaseItem = async (item) => {
    const comm = item?.module_object;
    const customerId = comm?.customer?.id;
    if (!customerId || !comm?.id) return;
    setSavingCommCaseEdit(true);
    try {
      const res = await updateCustomerCommunication(customerId, comm.id, {
        subject: commCaseEditDraft.subject || "",
        body_text: commCaseEditDraft.body_text || "",
      });
      if (res?.errors?.length) {
        toast.error(res.errors[0]);
        return;
      }
      if (res?.id) {
        toast.success(t("customer.handler.communication.update.success"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.map((i) =>
            i.id === item.id
              ? {
                  ...i,
                  module_object: {
                    ...i.module_object,
                    ...res,
                    customer: i.module_object?.customer || comm?.customer,
                  },
                }
              : i
          ),
        }));
        setEditingCommCaseItemId(null);
        setCommCaseEditDraft({ subject: "", body_text: "" });
      } else {
        toast.error(t("failed.to.update.communication"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("failed.to.update.communication"));
    } finally {
      setSavingCommCaseEdit(false);
    }
  };

  const handleUpdateCaseItem = async (itemId, payload) => {
    if (!caseItem?.id) return;
    try {
      const response = await updateCaseItem(caseItem.id, itemId, payload);
      const item = response?.data || response;
      if (item?.id) {
        toast.success(t("Update saved"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: prev.data.map((i) => (i.id === itemId ? item : i)),
        }));
        setEditingItemId(null);
      } else {
        const errMsg = item?.errors?.[0] || t("Could not save");
        toast.error(errMsg);
      }
    } catch (err) {
      toast.error(t("Could not save"));
    }
  };

  const handleAddCaseItem = async (payload) => {
    if (!caseItem?.id) return;
    try {
      const response = await createCaseItem(payload);
      const item = response?.data || response;
      if (item?.id) {
        toast.success(t("Update added"));
        setCaseItemsState((prev) => ({
          ...prev,
          data: sortCaseItemsAsc([...(prev.data || []), item]),
          totalCount: prev.totalCount + 1,
        }));
        setItemDocumentRefreshMap((prev) => ({
          ...prev,
          case: (prev.case || 0) + 1,
        }));
        requestAnimationFrame(() => {
          scrollItemsToComposer();
        });
      } else {
        const errMsg = item?.errors?.[0] || item?.data?.errors?.[0] || t("Could not add update");
        toast.error(errMsg);
        throw new Error(errMsg);
      }
    } catch (err) {
      toast.error(t("Could not add update"));
      throw err;
    }
  };

  // if (itemTags && caseItem?.id === null) {
  //   useEffect(() => {
  //     const tags = itemTags.map((item) => {
  //       return {
  //         module: item.module,
  //         module_param: item.module_param,
  //         object: item.object,
  //       };
  //     });

  //     // add to first item in items
  //     setItemState((prevState) => ({
  //       ...prevState,
  //       caseItem: {
  //         ...prevState.caseItem,
  //         items: [{ description: "", tags: tags }],
  //       },
  //     }));
  //   }, [itemTags]);
  // }

  function caseInputs(formik) {
    const priority = priorityOptions.find(
      (opt) => String(opt.value) === String(formik.values.priority)
    );
    const prioDot = { "1": "#16a34a", "2": "#d97706", "3": "#ea580c", "4": "#dc2626" }[
      String(formik.values.priority)
    ];
    const selectedType = caseTypeOptions.data?.find(
      (opt) => String(opt.value) === String(formik.values.case_type_id)
    );
    return (
      <div className="cv-fields">
        {caseItem?.id && (
          <div className="cv-field-grid">
            <div className="cv-field">
              <span className="cv-field-label">{t("Status")}</span>
              <button
                type="button"
                onClick={() => {
                  if (!canEditCase) {
                    presentCaseForbidden(
                      "CASE_EDIT_FORBIDDEN",
                      "cases.access.edit_forbidden"
                    );
                    return;
                  }
                  setShowStatusDialog(true);
                }}
                className="cv-field-select"
                aria-haspopup="listbox"
              >
                <span
                  className="cv-prio-dot"
                  style={{
                    background:
                      statusOptions.find(
                        (opt) =>
                          opt.value ===
                          String(formik.values.status || caseItem?.status || "").toUpperCase()
                      )?.dot || "#cbd5e1",
                  }}
                />
                <span className="truncate">{caseStatusMeta.label}</span>
                <ChevronDownIcon className="ml-auto h-4 w-4 text-slate-400" />
              </button>
            </div>
            <div className="cv-field">
              <span className="cv-field-label">{t("Priority")}</span>
              <button
                type="button"
                onClick={() => {
                  if (!canEditCase) {
                    presentCaseForbidden(
                      "CASE_EDIT_FORBIDDEN",
                      "cases.access.edit_forbidden"
                    );
                    return;
                  }
                  setShowPriorityDialog(true);
                }}
                className="cv-field-select"
                aria-haspopup="listbox"
              >
                <span
                  className="cv-prio-dot"
                  style={{ background: prioDot || "#cbd5e1" }}
                />
                <span className="truncate">
                  {priority?.label ? t(String(priority.label)) : t("Select Priority")}
                </span>
                <ChevronDownIcon className="ml-auto h-4 w-4 text-slate-400" />
              </button>
            </div>
          </div>
        )}

        <div className="cv-field">
          <PMField name="title" type="text" label={t("Tittel")} {...formik} />
        </div>

        {!props.customer?.id && (
          <div className="cv-field">
            <CustomerPicker
              value={pickedCustomer}
              setFieldValue={formik.setFieldValue}
              disabled={formik.isSubmitting}
              error={formik.touched.customer_id ? formik.errors.customer_id : undefined}
              onChange={(event) => {
                const row = event?.target?.data || null;
                setPickedCustomer(row);
                if (String(row?.id ?? "") !== String(formik.values.customer_id ?? "")) {
                  setPickedContact(null);
                  formik.setFieldValue("contact_id", null);
                }
              }}
            />
          </div>
        )}

        <div className="cv-field">
          <ContactPicker
            value={pickedContact}
            customer={
              pickedCustomer?.id != null
                ? pickedCustomer
                : formik.values.customer_id
                  ? { id: formik.values.customer_id }
                  : null
            }
            setFieldValue={formik.setFieldValue}
            disabled={formik.isSubmitting}
            error={formik.touched.contact_id ? formik.errors.contact_id : undefined}
            onChange={(event) => setPickedContact(event?.target?.data || null)}
          />
        </div>

        <div className="cv-field">
          <span className="cv-field-label">{t("Case Type")}</span>
          <button
            type="button"
            onClick={() => setShowCaseTypeDialog(true)}
            className="cv-field-select"
          >
            <span className="truncate">
              {selectedType?.title
                ? t(String(selectedType.title))
                : t("Select case type")}
            </span>
            <ChevronDownIcon className="ml-auto h-4 w-4 text-slate-400" />
          </button>
          {formik.errors.case_type_id && formik.touched.case_type_id && (
            <p className="mt-1 text-sm text-red-600">{formik.errors.case_type_id}</p>
          )}
        </div>

        <div className="cv-field">
          <PMDatePicker
            name="due_date"
            label={t("Forfallsdato")}
            value={
              typeof formik.values.due_date === "string" ? formik.values.due_date : ""
            }
            onChange={(e) => {
              formik.setFieldValue("due_date", e.target.value || null);
            }}
            errors={formik.errors.due_date}
            touched={formik.touched.due_date}
          />
        </div>

        <div className="cv-field">
          <CaseUserAssignedField
            userId={formik.values.user_assigned_id}
            caseUserAssigned={caseItem?.user_assigned}
            userOptions={userOptions.data}
            formik={formik}
          />
        </div>

        <div className="cv-field">
          <CaseTagSelector
            name="tag_ids"
            formik={formik}
            variant="combobox"
            label={t("Labels")}
            labelClassName="cv-field-label"
          />
        </div>

        {!caseItem?.id && (
          <div className="cv-field">
            <label htmlFor="description" className="cv-field-label">
              {t("Description")}
            </label>
            <textarea
              wrap="off"
              rows={4}
              name="description"
              id="description"
              className="block w-full rounded-md border-gray-300 text-gray-900 text-sm placeholder:text-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              placeholder={t("Write a description...")}
              value={typeof formik.values?.items?.[0]?.description === "string" ? formik.values.items[0].description : ""}
              onChange={(e) => handleDescriptionItemChange(e, formik)}
            />
          </div>
        )}
      </div>
    );
  }
  const timeToClockString = (dateTime) => {
    if (dateTime == null) return "";
    const str = typeof dateTime === "string" ? dateTime : String(dateTime);
    return new Date(str).toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit", hour12: false });
  };

  const getDateGroupLabel = (dateTime) => {
    if (dateTime == null) return "";
    const d = new Date(dateTime);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return t("I dag");
    if (d.toDateString() === yesterday.toDateString()) return t("I går");
    return d.toLocaleDateString("nb-NO", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  };

  const isItemEdited = (item) => {
    if (!item?.created_at || !item?.updated_at) return false;
    const created = new Date(item.created_at).getTime();
    const updated = new Date(item.updated_at).getTime();
    return updated - created > 2000;
  };

  // Changes whenever the feed changes (item added / edited / reloaded) so the
  // auto-updating AI summary can refetch itself. No manual refresh in the UI.
  const caseSummaryRefreshSignal = useMemo(() => {
    const data = caseItemsState?.data || [];
    const last = data[data.length - 1];
    return `${caseItemsState?.totalCount || 0}:${last?.id || 0}:${last?.updated_at || ""}`;
  }, [caseItemsState?.totalCount, caseItemsState?.data]);

  function caseItems() {
    if (caseItemsState.isLoading) {
      return (
        <div className="cv-feed-inner">
          <CaseSummaryCard caseId={caseItem?.id} refreshSignal={caseSummaryRefreshSignal} />
          <ResourceLoading />
        </div>
      );
    }

    const itemsByDate = (caseItemsState?.data || [])
      .filter((item) => !isEmailSummaryItem(item))
      .reduce((acc, item) => {
        const key = item?.created_at ? new Date(item.created_at).toDateString() : "unknown";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

    const sortedDateKeys = Object.keys(itemsByDate).sort((a, b) => new Date(a) - new Date(b));

    const renderItemActions = (item) => (
      <div className="cv-comment-actions">
        {canModifyItem(item) &&
          (item?.module === "description" ||
            (item?.module === "case" && item?.action === "UPDATE")) && (
            <button
              type="button"
              onClick={() => {
                setEditingCommCaseItemId(null);
                setCommCaseEditDraft({ subject: "", body_text: "" });
                setEditingItemId(item.id);
                setEditingItemDraft({
                  title: typeof item.title === "string" ? item.title : "",
                  description: typeof item.description === "string" ? item.description : "",
                });
              }}
              className="cv-icon-btn"
              title={t("Edit")}
            >
              <PencilSquareIcon className="h-4 w-4" />
            </button>
          )}
        {item?.module === "customer_communication" &&
          canEditOwnCustomerHandlerCommunication(item.module_object) && (
            <button
              type="button"
              onClick={() => {
                setEditingItemId(null);
                setEditingItemDraft({ title: "", description: "" });
                const comm = item.module_object;
                setEditingCommCaseItemId(item.id);
                setCommCaseEditDraft({
                  subject: typeof comm?.subject === "string" ? comm.subject : "",
                  body_text: typeof comm?.body_text === "string" ? comm.body_text : "",
                });
              }}
              className="cv-icon-btn"
              title={t("customer.handler.edit.communication")}
            >
              <PencilSquareIcon className="h-4 w-4" />
            </button>
          )}
        {canModifyItem(item) && (
          <button
            type="button"
            onClick={() => handleDeleteItem(item.id)}
            className="cv-icon-btn danger"
            title={t("Delete")}
          >
            <TrashIcon className="h-4 w-4" />
          </button>
        )}
      </div>
    );

    const renderItemBody = (item) => (
      <>
        {editingItemId === item.id &&
          (item?.module === "description" ||
            (item?.module === "case" && item?.action === "UPDATE")) && (
            <div className="mt-2 p-2.5 rounded-lg border border-blue-200 bg-blue-50/50">
              <input
                type="text"
                value={typeof editingItemDraft.title === "string" ? editingItemDraft.title : ""}
                onChange={(e) => setEditingItemDraft((p) => ({ ...p, title: e.target.value }))}
                placeholder={t("Title (optional)")}
                className="mb-2 w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
              />
              <MentionTextEditor
                value={
                  typeof editingItemDraft.description === "string"
                    ? editingItemDraft.description
                    : ""
                }
                onChange={(v) => setEditingItemDraft((p) => ({ ...p, description: v }))}
                minHeight={80}
                maxHeight={150}
              />
              <div className="mt-2 flex gap-2">
                <button
                  type="button"
                  onClick={() =>
                    handleUpdateCaseItem(item.id, {
                      title: editingItemDraft.title,
                      description: editingItemDraft.description || " ",
                    })
                  }
                  className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
                >
                  {t("Save")}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setEditingItemId(null);
                    setEditingItemDraft({ title: "", description: "" });
                  }}
                  className="rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                >
                  {t("Cancel")}
                </button>
              </div>
            </div>
          )}

        {editingCommCaseItemId === item.id &&
          item?.module === "customer_communication" &&
          item?.module_object?.id && (
            <div className="mt-2 p-2.5 rounded-lg border border-blue-200 bg-blue-50/50">
              <input
                type="text"
                value={commCaseEditDraft.subject}
                onChange={(e) =>
                  setCommCaseEditDraft((p) => ({ ...p, subject: e.target.value }))
                }
                placeholder={t("customer.handler.communication.subject")}
                className="mb-2 w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
              />
              <textarea
                rows={5}
                value={commCaseEditDraft.body_text}
                onChange={(e) =>
                  setCommCaseEditDraft((p) => ({ ...p, body_text: e.target.value }))
                }
                placeholder={t("customer.handler.communication.body")}
                className="w-full rounded border border-gray-200 px-2 py-1.5 text-sm"
              />
              <div className="mt-2 flex gap-2">
                <button
                  type="button"
                  disabled={savingCommCaseEdit}
                  onClick={() => handleSaveCustomerCommunicationCaseItem(item)}
                  className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700 disabled:opacity-50"
                >
                  {t("Save")}
                </button>
                <button
                  type="button"
                  disabled={savingCommCaseEdit}
                  onClick={() => {
                    setEditingCommCaseItemId(null);
                    setCommCaseEditDraft({ subject: "", body_text: "" });
                  }}
                  className="rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                >
                  {t("Cancel")}
                </button>
              </div>
            </div>
          )}

        {editingItemId !== item.id && editingCommCaseItemId !== item.id && (
          <div className="cv-comment-body">
            {item?.module === "description" &&
              typeof item?.title === "string" &&
              item.title.trim() && (
                <p className="font-semibold text-gray-900 mb-1">{item.title}</p>
              )}
            {displayModuleContent(item)}
            {item?.module !== "customer_communication" &&
              item?.module !== "case_guide_run" &&
              item?.module !== "weply" &&
              typeof item?.description === "string" &&
              item.description.trim() !== "" && (
                <>
                  <div
                    className={TWclassNames(
                      "cv-comment-text",
                      isItemLong(item) && !isItemExpanded(item.id) && "is-clamped"
                    )}
                  >
                    <CaseItemDescription value={item.description} />
                  </div>
                  {isItemLong(item) && (
                    <button
                      type="button"
                      onClick={() => toggleItemExpansion(item.id)}
                      className="cv-show-more"
                    >
                      {isItemExpanded(item.id) ? t("Vis mindre") : t("Vis mer")}
                    </button>
                  )}
                </>
              )}
            {item?.tags && item.tags.length > 0 && (
              <div className="mt-2">
                <TagsView tags={item?.tags} />
              </div>
            )}
            {item?.documents?.length > 0 && (
              <div className="mt-3">
                <TinyDocumentSection
                  showNoDocuments={false}
                  pathType="url"
                  module="CASE_ITEM"
                  moduleParam={item?.id}
                  refreshTrigger={itemDocumentRefreshMap[item?.id] || 0}
                />
              </div>
            )}
          </div>
        )}
      </>
    );

    return (
      <div className="cv-feed-inner">
        <CaseSummaryCard caseId={caseItem?.id} refreshSignal={caseSummaryRefreshSignal} />
        <ul role="list" className="cv-feed-list">
          {caseItemsState.isLoadingMore && (
            <li className="py-2 text-xs text-slate-500">{t("Laster eldre oppdateringer...")}</li>
          )}
          {sortedDateKeys.map((dateKey) => (
            <Fragment key={dateKey}>
              <li className="cv-date-sep" aria-hidden="false">
                <span>{getDateGroupLabel(itemsByDate[dateKey][0]?.created_at)}</span>
              </li>
              {itemsByDate[dateKey].map((item) => {
                const edited = isItemEdited(item);
                const authorName = safeString(item?.user?.name, t("histories.system_user"));
                const isEmailItem = item?.action === "EMAIL_SENT_TO_EMPLOYEE";
                const isSystemItem = item?.action === "CHANGED";

                if (isEmailItem) {
                  const label =
                    item?.module_object?.displayTitle || item?.module_object?.name;
                  const userId = item?.module_object?.id ?? item?.module_param;
                  return (
                    <li key={item.id} className="cv-email-row">
                      <div className="cv-email-icon" aria-hidden="true">
                        <EnvelopeOpenIcon className="h-4 w-4" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="cv-comment-head">
                          <span className="cv-comment-author">{authorName}</span>
                          <span className="cv-comment-time">
                            {t("case.view.sent_email_to_employee")}
                          </span>
                          <time className="cv-comment-time" dateTime={item?.created_at}>
                            {timeToClockString(item?.created_at)}
                          </time>
                          {renderItemActions(item)}
                        </div>
                        <div className="cv-email-chip">
                          <EnvelopeOpenIcon className="h-4 w-4 text-[#1B6FE0]" />
                          <div>
                            <div className="cv-email-chip-title">
                              {t("Sendt e-post til ansatt")}
                            </div>
                            <div className="cv-email-chip-sub">
                              {(() => {
                                const employeeLabel = safeString(label);
                                if (employeeLabel && userId) {
                                  return (
                                    <Link to={`/dashboard/users/${userId}`}>
                                      {employeeLabel}
                                    </Link>
                                  );
                                }
                                if (employeeLabel) return employeeLabel;
                                if (userId) {
                                  return (
                                    <Link to={`/dashboard/users/${userId}`}>
                                      {t("Ansatt")} #{userId}
                                    </Link>
                                  );
                                }
                                return t("Ansatt");
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                }

                if (isSystemItem) {
                  return (
                    <li key={item.id} className="cv-system-row">
                      <div className="cv-system-icon" aria-hidden="true">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <span className="cv-system-text">
                        <b>{authorName}</b>{" "}
                        {item?.item_change ? (
                          <ChangedValues module={item?.action} change={item?.item_change} />
                        ) : (
                          itemActivityLabel(item)
                        )}
                      </span>
                      <time className="cv-comment-time" dateTime={item?.created_at}>
                        {timeToClockString(item?.created_at)}
                      </time>
                      {renderItemActions(item)}
                    </li>
                  );
                }

                return (
                  <li
                    key={item.id}
                    className={TWclassNames(
                      "cv-comment",
                      unreadMailHighlightIds.has(item.id) && "is-unread-mail"
                    )}
                    aria-label={
                      unreadMailHighlightIds.has(item.id)
                        ? t("case.unread_mail.glow_aria")
                        : undefined
                    }
                  >
                    <div
                      className="cv-avatar"
                      style={{ background: caseAvatarColor(authorName) }}
                      aria-hidden="true"
                    >
                      {caseAvatarInitials(authorName)}
                    </div>
                    <div className="cv-comment-card">
                      <div className="cv-comment-head">
                        <span className="cv-comment-author">{authorName}</span>
                        <span className="cv-comment-time">{itemActivityLabel(item)}</span>
                        <time className="cv-comment-time" dateTime={item?.created_at}>
                          {timeToClockString(item?.created_at)}
                        </time>
                        {item?.priority != null && item.priority !== "" && (
                          <CasePriorityStatus priority={item.priority} />
                        )}
                        {edited && (
                          <span className="cv-comment-time italic">({t("Redigert")})</span>
                        )}
                        {unreadMailHighlightIds.has(item.id) && (
                          <span className="cv-unread-mail-pill">
                            {t("case.unread_mail.item_label")}
                          </span>
                        )}
                        {renderItemActions(item)}
                      </div>
                      {item?.item_change && item?.action !== "CHANGED" && (
                        <div className="py-1.5">
                          <ChangedValues module={item?.action} change={item?.item_change} />
                        </div>
                      )}
                      {renderItemBody(item)}
                    </div>
                  </li>
                );
              })}
            </Fragment>
          ))}
          {caseItemsState.error && (
            <li className="list-none">
              <div
                className="flex flex-col items-center gap-2 py-4 text-center"
                role="alert"
              >
                <p className="text-sm font-medium text-rose-600">
                  {t("case.feed.error_title")}
                </p>
                <button
                  type="button"
                  className="cv-show-more"
                  onClick={() => fetchItemsPage(id, 1, false)}
                >
                  {t("case.load.retry")}
                </button>
              </div>
            </li>
          )}
          {!caseItemsState.error && !caseItemsState?.data?.length && (
            <li className="list-none">
              <div className="cv-empty">
                <p className="cv-empty-title">{t("case.empty.updates")}</p>
                <p className="cv-empty-hint">{t("case.empty.hint")}</p>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }

  const IsEditingListner = () => {
    // const { values } = useFormikContext();
    // useEffect(() => {
    //   onEditing(true);
    // }, [values]);
  };

  const [finishCase, setFinishCase] = useState(false);
  const [mailThreadOpen, setMailThreadOpen] = useState(false);
  const [linkMailOpen, setLinkMailOpen] = useState(false);
  const [customerEmailMode, setCustomerEmailMode] = useState(null);
  const [mailReader, setMailReader] = useState(null);
  const [finishQuestionPromptOpen, setFinishQuestionPromptOpen] =
    useState(false);
  const [moduleType, setModuleType] = useState(null);

  const onUpdateModuleChange = (type, data) => {
    // ids objects depending on type
    const id_name = {
      report: "report_id",
      project: "project_id",
      service_agreement: "service_agreement_id",
    };

    const payload = {
      id: caseItem.id,
      [id_name[type]]: data?.id,
    };

    // add status: 'FINISH' if report is finished
    if (finishCase) {
      payload.status = "FINISHED";
    }

    const operation = dispatch(updateCaseAsync(payload));
    setFinishCase(false);
    return operation;
  };

  const promptBeforeModuleDialog = (type) => {
    setModuleType(type);
    if (!caseItem?.[type]?.id) {
      setFinishQuestionPromptOpen(true);
    } else {
      openModuleDialog(type);
    }
  };

  const handleFinishQuestion = (boolean) => {
    if (boolean) {
      setFinishCase(boolean);
    }
    setFinishQuestionPromptOpen(false);
    openModuleDialog(moduleType);
  };

  const openModuleDialog = (type) => {
    // Open module dialog depending on type
    switch (type) {
      case "report":
        setReportDialogOpen(true);
        break;
      case "service_agreement":
        setServiceAgreementDialogOpen(true);
        break;
      default:
        toast.error("Missing dialog for this module");
        break;
    }
  };

  // Format caseItem fields to find object by name.
  // Guard Array.isArray: a non-array `fields` payload would throw on .reduce and
  // bubble to OpsErrorBoundary («Kunne ikke laste inn»).
  const caseItemFields = Array.isArray(caseItem?.fields)
    ? caseItem.fields.reduce((acc, field) => {
        if (field?.name != null) acc[field.name] = field.value;
        return acc;
      }, {})
    : {};

  function handleNewCaseItems(data) {
    setCaseItemsState((prev) => ({
      ...prev,
      data: sortCaseItemsAsc([...(prev.data || []), data]),
      totalCount: prev.totalCount + 1,
    }));

    // Only trigger document refresh for the specific new item
    setItemDocumentRefreshMap(prev => ({
      ...prev,
      [data.id]: (prev[data.id] || 0) + 1
    }));
  }

  const [closeCasepromptOpen, setCloseCasepromptOpen] = useState(false);
  const [finishCasepromptOpen, setFinishCasepromptOpen] = useState(false);
  const [removeCasePromptOpen, setRemoveCasePromptOpen] = useState(false);
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [siblingOpenCases, setSiblingOpenCases] = useState([]);
  const [itemDocumentRefreshMap, setItemDocumentRefreshMap] = useState({});

  useEffect(() => {
    setPickedCustomer(
      caseItem?.customer?.id ? caseItem.customer : customer?.id ? customer : null
    );
    setPickedContact(
      caseItem?.contact?.id ? caseItem.contact : contact?.id ? contact : null
    );
  }, [
    caseItem?.id,
    caseItem?.customer?.id,
    caseItem?.contact?.id,
    customer?.id,
    contact?.id,
  ]);

  useEffect(() => {
    if (!caseItem?.id || !caseItem?.customer?.id) {
      setSiblingOpenCases([]);
      return;
    }
    let cancelled = false;
    fetchSiblingOpenCases(caseItem.id).then((res) => {
      if (cancelled) return;
      setSiblingOpenCases(Array.isArray(res?.data) ? res.data : []);
    });
    return () => {
      cancelled = true;
    };
  }, [caseItem?.id, caseItem?.customer?.id]);

  const updateAndCloseCase = async (formik) => {
    if (!canEditCase) {
      presentCaseForbidden("CASE_EDIT_FORBIDDEN", "cases.access.edit_forbidden");
      return;
    }
    await formik.setFieldValue("status", "CLOSED");
    await formik.submitForm();
    navigate("/dashboard/cases");
  };

  const updateAndFinishCase = async (formik) => {
    if (!canEditCase) {
      presentCaseForbidden("CASE_EDIT_FORBIDDEN", "cases.access.edit_forbidden");
      return;
    }
    await formik.setFieldValue("status", "FINISHED");
    await formik.submitForm();
    navigate("/dashboard/cases");
  };

  const removeCase = async (id) => {
    dispatchWithToast(
      dispatch(deleteCaseAsync({ id: id }), null, navigate("/dashboard/cases"))
    );
  };

  const canTransferCase =
    caseItem?.id &&
    !caseItem?.transferred_to_case?.id &&
    String(caseItem?.status || "").toUpperCase() !== "CLOSED";

  const dropdownActions = [
    {
      label: "edit",
      children: [
        ...(canEditCase
          ? [
              {
                label: t("Save and finish"),
                icon: PencilSquareIcon,
                action: () => setFinishCasepromptOpen(true),
              },
              {
                label: t("Save and close"),
                icon: PencilSquareIcon,
                action: () => setCloseCasepromptOpen(true),
              },
            ]
          : []),
        ...(canTransferCase && canEditCase
          ? [
              {
                label: t("case.transfer.action"),
                icon: ArrowsRightLeftIcon,
                action: () => setTransferDialogOpen(true),
              },
            ]
          : []),
        ...(canWriteCase
          ? [
              {
                label: t("Etterspørre info"),
                icon: QuestionMarkCircleIcon,
                action: () => openCaseGuide(caseItem?.case_type?.id, "request_info"),
              },
              {
                label: t("case.mail_thread.reply_title"),
                icon: EnvelopeIcon,
                action: () => setCustomerEmailMode("reply"),
              },
              {
                label: t("case.mail_thread.compose_title"),
                icon: EnvelopeOpenIcon,
                action: () => setCustomerEmailMode("compose"),
              },
              {
                label: t("case.mail_thread.link_title"),
                icon: EnvelopeOpenIcon,
                action: () => setLinkMailOpen(true),
              },
            ]
          : []),
        ...rightSideActions
          .filter((a) => a.show !== false)
          .map((a) => ({
            label: t(a.label),
            icon: a.icon,
            action: a.action,
          })),
        ...(canEditCase
          ? [
              {
                label: t("Delete"),
                icon: TrashIcon,
                action: () => setRemoveCasePromptOpen(true),
              },
            ]
          : []),
      ],
    },
  ];

  const handleCaseTransferred = (payload) => {
    const targetId = payload?.target?.id || payload?.data?.target?.id;
    if (targetId) {
      navigate(`/dashboard/cases/${targetId}`);
      return;
    }
    retryLoadCase();
  };

  const fieldOrCustomerAddressObject = (item) => {
    if (
      item?.customer?.postal_address &&
      item?.customer?.postal_address?.address !== "null"
    ) {
      return item?.customer?.postal_address;
    }

    const address = searchFieldsByName(item, "address")?.value;

    if (address) {
      const address2 = searchFieldsByName(item, "address2")?.value;
      const postal = searchFieldsByName(item, "postal")?.value;
      const place = searchFieldsByName(item, "place")?.value;

      // find fields

      return {
        address: address,
        address2: address2,
        postal: postal,
        place: place,
      };
    }

    return null;
  };

  return (
    <>
      <SeoHelmetWrapper
        title={t("Cases")}
        subtitle={
          caseItem?.id
            ? `SAK-${safeString(caseItem?.case_number)}`
            : safeString(caseItem?.customer?.displayTitle)
        }
      />
      {isLoading ? (
        <div className="flex h-screen items-center justify-center">
          <ResourceLoading />
        </div>
      ) : id && error ? (
        // A specific case was requested (URL :id) but loading failed — show a calm
        // error panel with retry instead of the misleading "new case" create form.
        <div className="case-view-redesign flex min-h-0 flex-1 flex-col items-center justify-center p-6">
          <div className="cv-empty" role="alert">
            <p className="cv-empty-title">{t("case.load.error_title")}</p>
            <p className="cv-empty-hint">{t("case.load.error_hint")}</p>
            {Array.isArray(errors) && errors.length > 0 && (
              <p className="cv-empty-hint">{errors.join(", ")}</p>
            )}
            <button
              type="button"
              className="cv-btn cv-btn-primary mt-4"
              onClick={retryLoadCase}
            >
              {t("case.load.retry")}
            </button>
          </div>
        </div>
      ) : (
        <div className="case-view-redesign flex min-h-0 flex-col overflow-hidden">
            <Formik
              enableReinitialize
              initialValues={{
                id: caseItem?.id,
                customer_id: caseItem?.customer
                  ? caseItem?.customer?.id
                  : customer?.id
                  ? customer?.id
                  : null,
                contact_id: caseItem?.contact
                  ? caseItem?.contact?.id
                  : contact?.id
                  ? contact?.id
                  : null,
                report_id: caseItem?.report
                  ? caseItem?.report?.id
                  : report?.id
                  ? report?.id
                  : null,
                project_id: caseItem?.project
                  ? caseItem?.project?.id
                  : project?.id
                  ? project?.id
                  : null,
                case_number: caseItem?.case_number,
                date: caseItem?.date
                  ? caseItem?.date
                  : new Date().toISOString().substring(0, 10),
                title: safeString(caseItem?.title) || safeString(title) || "",
                description: caseItem?.description,
                case_type_id: caseItem?.case_type?.id,
                module: props?.module,
                module_param: props?.module_param,
                user_responsible_id: caseItem?.user_responsible?.id,
                user_assigned_id:
                  caseItem?.user_assigned?.id || currentUser?.id,
                note: caseItem?.note,
                status: caseItem?.status || (caseItem?.id ? "NEW" : undefined),
                priority: caseItem?.priority?.toString() || "1",
                due_date: (() => {
                  const d = caseItem?.due_date;
                  if (typeof d === "string") return d;
                  if (d?.date) return d.date;
                  return new Date().toISOString().substring(0, 10);
                })(),
                tag_ids: caseItem?.tag_definitions?.map((t) => t.id) ?? [],

                items: [
                  {
                    description: null,
                  },
                ],

                submit: null,
              }}
              validationSchema={Yup.object({
                case_type_id: Yup.string().required("A case type is required"),
              })}
              onSubmit={async (values, helpers) => {
                if (!caseItem?.id) {
                  if (!canCreateCase) {
                    helpers.setSubmitting(false);
                    presentCaseForbidden(
                      "CASE_CREATE_FORBIDDEN",
                      "cases.access.create_forbidden"
                    );
                    return;
                  }
                  try {
                    const result = await createOrUpdateDispatch(values);
                    const payload = result?.payload ?? result;
                    if (caseWriteFailed(payload)) {
                      helpers.setErrors({
                        submit: caseWriteErrorMessage(payload, "Request failed"),
                      });
                      helpers.setSubmitting(false);
                      return;
                    }
                    const createdCase = normalizeCaseItem(payload?.data ?? payload);
                    const pendingGuideRun = caseGuideState.pendingRun;
                    if (createdCase?.id && pendingGuideRun) {
                      const guideResponse = await createCaseGuideRun(
                        createdCase.id,
                        {
                          case_guide_template_id: pendingGuideRun.case_guide_template_id,
                          purpose: pendingGuideRun.purpose,
                          answers: pendingGuideRun.answers,
                          requested_from_customer: false,
                        },
                        { fields: CASE_DETAIL_FIELDS_WITHOUT_ITEMS }
                      );
                      if (guideResponse?.errors) {
                        toast.error(Array.isArray(guideResponse.errors) ? guideResponse.errors.join(", ") : String(guideResponse.errors));
                        setCaseGuideState((prev) => ({ ...prev, pendingRun: null }));
                      } else {
                        if (guideResponse?.case) {
                          Object.assign(createdCase, normalizeCaseItem(guideResponse.case));
                        }
                        const chained = await chainNextGuideIfNeeded(createdCase.id, guideResponse, pendingGuideRun.purpose);
                        if (!chained) {
                          setCaseGuideState((prev) => ({ ...prev, pendingRun: null }));
                        }
                      }
                    }
                    setItemState((prevState) => ({
                      ...prevState,
                      caseItem: createdCase,
                    }));
                    if (!id && createdCase?.id) {
                      navigate(`/dashboard/cases/${createdCase.id}`, { replace: true });
                    }
                    helpers.setStatus({ success: true });
                  } catch (err) {
                    console.error(err);
                    helpers.setStatus({ success: false });
                    helpers.setErrors({ submit: err.message });
                  }
                  helpers.setSubmitting(false);
                  return;
                }
                if (!canEditCase) {
                  helpers.resetForm();
                  helpers.setSubmitting(false);
                  presentCaseForbidden(
                    "CASE_EDIT_FORBIDDEN",
                    "cases.access.edit_forbidden"
                  );
                  return;
                }
                setSaveState((s) => ({ ...s, isSaving: true, isError: false, isSuccess: false, errorMessage: null }));
                // Løpenummer for denne lagringen. Et nyere lagringskall (mySeq <
                // saveSeqRef.current når svaret kommer) betyr at dette svaret er
                // utdatert og ikke skal skrive over skjema/caseItem.
                const mySeq = ++saveSeqRef.current;
                const submittedSignature = caseValuesSignature(values);
                try {
                  const result = await createOrUpdateDispatch(values);
                  const payload = result?.payload ?? result;
                  const errs = payload?.errors ?? payload?.data?.errors;
                  const isStale = mySeq !== saveSeqRef.current;
                  if (errs) {
                    if (!isStale) {
                      setSaveState({
                        isSaving: false,
                        isError: true,
                        errorMessage: Array.isArray(errs) ? errs.join(", ") : String(errs),
                      });
                    }
                    return;
                  }
                  if (payload?.id) {
                    // Et nyere lagringskall har allerede startet — ignorer dette
                    // utdaterte svaret helt, så det ikke overskriver nyere state.
                    if (isStale) return;

                    // Har brukeren endret noe mens lagringen var underveis? Da må vi
                    // IKKE skrive den nå utdaterte server-payloaden inn i skjemaet
                    // (enableReinitialize ville nullstilt den nye endringen). Behold
                    // de nyeste verdiene og lagre dem umiddelbart på nytt.
                    const currentValues = formikRef.current?.values || values;
                    const hasPendingEdits =
                      caseValuesSignature(currentValues) !== submittedSignature;

                    if (hasPendingEdits) {
                      setSaveState({ isSaving: false, isSuccess: true });
                      if (saveTimeoutRef.current) {
                        clearTimeout(saveTimeoutRef.current);
                        saveTimeoutRef.current = null;
                      }
                      // Formik blokkerer nye submit mens isSubmitting=true; slipp den
                      // først (finally under), så trigg lagring av de nyeste verdiene.
                      setTimeout(() => {
                        if (mySeq === saveSeqRef.current) formikRef.current?.submitForm();
                      }, 0);
                      return;
                    }

                    setItemState((prevState) => ({
                      ...prevState,
                      caseItem: normalizeCaseItem(payload) ?? payload,
                    }));
                    setSaveState({ isSaving: false, isSuccess: true });
                    helpers.resetForm({ values });
                  } else if (!isStale) {
                    setSaveState({ isSaving: false, isError: true, errorMessage: t("Could not save") });
                  }
                } catch (err) {
                  console.error(err);
                  if (mySeq === saveSeqRef.current) {
                    setSaveState({
                      isSaving: false,
                      isError: true,
                      errorMessage: err?.message || t("Could not save"),
                    });
                  }
                } finally {
                  helpers.setSubmitting(false);
                }
              }}
            >
              {(formik) => {
                formikRef.current = formik;
                return (
                <>
                <PostCreateGuidePrompt />
                {caseItem?.id && (
                  <>
                    <CaseFormFocusListeners
                      sidebarRef={caseFormSidebarRef}
                      panelRef={caseFormPanelRef}
                      formikRef={formikRef}
                      caseId={caseItem.id}
                    />
                    <CaseAutosaveWatcher formik={formik} caseId={caseItem.id} />
                  </>
                )}
                <Form className="cv-shell">
                  <div className="cv-main">
                    {caseItem?.id && (
                      <header className="cv-header">
                        <nav className="cv-crumbs" aria-label="Breadcrumb">
                          <Link to="/dashboard">{t("Dashboard")}</Link>
                          <span className="cv-crumbs-sep">/</span>
                          <Link to="/dashboard/cases">{t("Cases")}</Link>
                          <span className="cv-crumbs-sep">/</span>
                          <span className="cv-crumbs-current">
                            SAK-{safeString(caseItem?.case_number)}
                          </span>
                        </nav>
                        <div className="cv-header-row">
                          <div className="cv-title-block">
                            <div className="cv-title-line">
                              <h1 className="cv-title">
                                {safeString(caseItem?.title) || t("Mangler tittel")}
                              </h1>
                              <span className="cv-case-id">
                                SAK-{safeString(caseItem?.case_number)}
                              </span>
                              <span className={TWclassNames("cv-status-pill", caseStatusMeta.className)}>
                                <span className="cv-dot" />
                                {caseStatusMeta.label}
                              </span>
                              <CaseEmailNoticeChips
                                emails={caseItem?.linked_emails}
                                hasThread={Boolean(caseItem?.mail_thread?.has_thread)}
                                onOpenThread={() => setMailThreadOpen(true)}
                              />
                              {caseHasUnreadEmailTag(caseItem) && <UnreadEmailTagBadge />}
                              <CaseHeaderRelationTags
                                caseItem={caseItem}
                                siblingCases={siblingOpenCases}
                              />
                            </div>
                            <div className="cv-meta">
                              {caseItem?.customer?.displayTitle && (
                                <span className="cv-meta-item">
                                  <BuildingOffice2Icon className="h-3.5 w-3.5" />
                                  {safeString(caseItem.customer.displayTitle)}
                                </span>
                              )}
                              {(() => {
                                const d = formik.values.due_date || caseItem?.due_date;
                                if (!d) return null;
                                const dueLabel =
                                  typeof d === "string"
                                    ? dateToString(d)
                                    : d?.date
                                    ? dateToString(d.date)
                                    : null;
                                if (!dueLabel) return null;
                                return (
                                  <span className="cv-meta-item">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                      <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                                      <path d="M16 2v4M8 2v4M3 10h18"></path>
                                    </svg>
                                    {t("case.view.due")} {dueLabel}
                                  </span>
                                );
                              })()}
                              {(() => {
                                const assignedName = safeString(
                                  caseItem?.user_assigned?.displayTitle ||
                                    caseItem?.user_assigned?.name ||
                                    ""
                                );
                                if (!assignedName) return null;
                                return (
                                  <span className="cv-meta-item">
                                    <span
                                      className="cv-avatar-sm"
                                      style={{ background: caseAvatarColor(assignedName) }}
                                    >
                                      {caseAvatarInitials(assignedName)}
                                    </span>
                                    {assignedName}
                                  </span>
                                );
                              })()}
                            </div>
                          </div>
                          <div className="cv-header-actions">
                            <button
                              type="button"
                              className="cv-btn cv-btn-secondary cv-details-trigger"
                              onClick={() => setCaseMenuOpen(true)}
                              aria-expanded={caseMenuOpen}
                              aria-controls="cv-case-details-panel"
                            >
                              <DocumentTextIcon className="h-4 w-4" />
                              {t("Saksdetaljer")}
                            </button>
                            {canWriteCase ? (
                            <button
                              type="button"
                              className="cv-btn cv-btn-secondary cv-header-desktop-action"
                              onClick={() =>
                                openCaseGuide(caseItem?.case_type?.id, "request_info")
                              }
                            >
                              <QuestionMarkCircleIcon className="h-3.5 w-3.5" />
                              {t("Etterspørre info")}
                            </button>
                            ) : null}
                            {canWriteCase ? (
                            <button
                              type="button"
                              className="cv-btn cv-btn-secondary cv-header-desktop-action"
                              onClick={() =>
                                caseItem?.mail_thread?.has_thread
                                  ? setCustomerEmailMode("reply")
                                  : setCustomerEmailMode("compose")
                              }
                            >
                              <EnvelopeIcon className="h-3.5 w-3.5" />
                              {caseItem?.mail_thread?.has_thread
                                ? t("case.mail_thread.reply_title")
                                : t("case.mail_thread.compose_title")}
                            </button>
                            ) : null}
                            {canCreateCase ? (
                            <button
                              type="button"
                              className="cv-btn cv-btn-primary cv-header-desktop-action"
                              onClick={() => setCreateCaseDialogOpen(true)}
                            >
                              <PlusIcon className="h-3.5 w-3.5" />
                              {t("case.view.new_case")}
                            </button>
                            ) : null}
                          </div>
                        </div>
                      </header>
                    )}

                    {caseItem?.id && (
                      <div
                        ref={caseContentScrollRef}
                        onScroll={handleCaseItemsScroll}
                        className="cv-feed"
                      >
                        {caseItems()}
                      </div>
                    )}

                    {caseItem?.id && canWriteCase && (
                      <div ref={composerRef} className="cv-composer">
                        <div className="cv-composer-inner">
                          <CaseUpdateComposer
                            caseId={caseItem.id}
                            onSubmit={handleAddCaseItem}
                            compact
                            customer={caseItem?.customer}
                          />
                        </div>
                      </div>
                    )}

                    {!caseItem?.id && (
                      <div className="cv-create">
                        <div className="flex items-center justify-between mb-4">
                          <h1 className="cv-title">{t("case.view.new_case")}</h1>
                          <button
                            type="button"
                            className="cv-btn cv-btn-primary"
                            onClick={formik.submitForm}
                          >
                            {t("Create")}
                          </button>
                        </div>
                        <div className="space-y-4">
                          <ObjectRenderErrorBoundary>{caseInputs(formik)}</ObjectRenderErrorBoundary>
                        </div>
                      </div>
                    )}
                  </div>

                  {caseItem?.id && (
                    <>
                      {caseMenuOpen ? (
                        <button
                          type="button"
                          className="cv-panel-scrim"
                          aria-label={t("Close")}
                          onClick={() => setCaseMenuOpen(false)}
                        />
                      ) : null}
                      <aside
                        id="cv-case-details-panel"
                        className={TWclassNames(
                          "cv-panel",
                          !caseMenuOpen && "is-collapsed",
                          caseMenuOpen && "is-open"
                        )}
                      >
                        <div className="cv-panel-drawer-head">
                          <div className="cv-panel-drawer-title">
                            <DocumentTextIcon className="h-5 w-5 text-[#1B6FE0]" aria-hidden="true" />
                            <span>{t("Saksdetaljer")}</span>
                            <span className={TWclassNames("cv-status-pill", caseStatusMeta.className)}>
                              {caseStatusMeta.label}
                            </span>
                          </div>
                          <button
                            type="button"
                            className="cv-panel-drawer-close"
                            onClick={() => setCaseMenuOpen(false)}
                            aria-label={t("Close")}
                          >
                            <XMarkIcon className="h-5 w-5" />
                          </button>
                        </div>

                        {caseTabs()}

                        <div
                          ref={(el) => {
                            caseFormSidebarRef.current = el;
                            caseFormPanelRef.current = el;
                          }}
                          className="cv-panel-body"
                        >
                          {currentTab === 0 && (
                            <div className="space-y-4">
                              <ObjectRenderErrorBoundary>{caseInputs(formik)}</ObjectRenderErrorBoundary>
                            </div>
                          )}
                          {currentTab === 1 && caseModulesTab()}
                          {currentTab === 2 && caseFields()}
                          {currentTab === 3 && (
                            <div className="py-2">
                              <TinyDocumentSection
                                module="CASE"
                                moduleParam={caseItem?.id}
                                title="Case Documents"
                                refreshTrigger={itemDocumentRefreshMap.case || 0}
                              />
                            </div>
                          )}
                        </div>

                        <div className="cv-panel-footer">
                          {formik.values.id ? (
                            <>
                              {rightSideActions.some((a) => a.show !== false) ? (
                                <div className="cv-add-module-rail">
                                  <p className="cv-add-module-rail-title">
                                    {t("case.quick_tools.title")}
                                  </p>
                                  <div className="cv-add-module-rail-list">
                                    {rightSideActions
                                      .filter((a) => a.show !== false)
                                      .map((a) => {
                                        const Icon = a.icon;
                                        return (
                                          <button
                                            key={a.label}
                                            type="button"
                                            className="cv-add-module-rail-btn"
                                            onClick={a.action}
                                          >
                                            {Icon ? <Icon className="h-4 w-4 shrink-0" /> : null}
                                            <span>{t(a.label)}</span>
                                          </button>
                                        );
                                      })}
                                  </div>
                                </div>
                              ) : null}
                              <PMDropdown
                                label={t("Handlinger")}
                                options={(() => {
                                  const addr = fieldOrCustomerAddressObject(caseItem);
                                  const mapsUrl =
                                    addr?.address && String(addr.address).length > 2
                                      ? `https://www.google.com/maps?q=${encodeURIComponent(
                                          [addr.address, addr.address2, addr.postal, addr.place]
                                            .filter(Boolean)
                                            .join(", ")
                                        )}`
                                      : null;
                                  return [
                                    ...dropdownActions,
                                    ...(mapsUrl
                                      ? [
                                          {
                                            label: t("Kart"),
                                            children: [
                                              {
                                                label: t("Åpne i Google Maps"),
                                                icon: MapIcon,
                                                action: () =>
                                                  window.open(mapsUrl, "_blank", "noreferrer"),
                                              },
                                            ],
                                          },
                                        ]
                                      : []),
                                  ];
                                })()}
                              />
                            </>
                          ) : null}
                          {canEditCase ? (
                          <button
                            type="button"
                            className="cv-btn cv-btn-secondary"
                            onClick={() => setCloseCasepromptOpen(true)}
                          >
                            <XCircleIcon className="h-4 w-4" />
                            {t("Lukk sak")}
                          </button>
                          ) : null}
                        </div>
                      </aside>
                    </>
                  )}
                </Form>

                <IsEditingListner />

                  {caseItem?.id && canEditCase && (
                    <SaveBar
                      /* Flyttet til øvre høyre hjørne som en kompakt toast, slik at
                         lagringsstatusen aldri dekker composeren nederst i saken. */
                      className="!top-[4.75rem] !bottom-auto !left-auto !right-3 !pb-0"
                      hasChanges={formik.dirty}
                      isSaving={saveState.isSaving}
                      isSuccess={saveState.isSuccess}
                      isError={saveState.isError}
                      errorMessage={saveState.errorMessage}
                      onSave={() => {
                        if (saveTimeoutRef.current) {
                          clearTimeout(saveTimeoutRef.current);
                          saveTimeoutRef.current = null;
                        }
                        formik.submitForm();
                      }}
                      onDismiss={() => {
                        setSaveState((s) => ({ ...s, isSuccess: false, isError: false, errorMessage: null }));
                      }}
                    />
                  )}

                  <SimplePrompt
                    title="Sikker på at du vill lukke saken?"
                    description="Saken lagres og lukkes, men kan åpnes igjen senere."
                    onAccept={() => updateAndCloseCase(formik)}
                    open={closeCasepromptOpen}
                    onClose={() => setCloseCasepromptOpen(false)}
                  />

                  <CaseTransferDialog
                    open={transferDialogOpen}
                    onClose={() => setTransferDialogOpen(false)}
                    sourceCase={caseItem}
                    onTransferred={handleCaseTransferred}
                  />
                  <CaseMailThreadDialog
                    open={mailThreadOpen}
                    onClose={() => setMailThreadOpen(false)}
                    caseId={caseItem?.id}
                    mailboxId={caseItem?.mail_thread?.mailbox_id}
                    mailboxEmail={caseItem?.mail_thread?.mailbox_email}
                  />
                  <CompanyAiMailboxMessageReaderDialog
                    open={Boolean(mailReader?.graph_message_id && caseItem?.mail_thread?.mailbox_id)}
                    onClose={() => setMailReader(null)}
                    mailboxId={caseItem?.mail_thread?.mailbox_id}
                    mailboxEmail={caseItem?.mail_thread?.mailbox_email}
                    graphMessageId={mailReader?.graph_message_id}
                    previewSubject={mailReader?.subject}
                    zIndex={3600}
                  />
                  <CaseLinkMailThreadDialog
                    open={linkMailOpen}
                    onClose={() => setLinkMailOpen(false)}
                    caseId={caseItem?.id}
                    onLinked={() => getCase()}
                  />
                  <CaseCustomerEmailDialog
                    open={Boolean(customerEmailMode)}
                    onClose={() => setCustomerEmailMode(null)}
                    caseItem={caseItem}
                    mode={customerEmailMode || "reply"}
                    onSent={() => getCase()}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill endre status til ferdig?"
                    description="Saken lagres og markeres som ferdig"
                    onAccept={() => updateAndFinishCase(formik)}
                    open={finishCasepromptOpen}
                    onClose={() => setFinishCasepromptOpen(false)}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill slette saken?"
                    description="Saken slettes permanent."
                    onAccept={() => removeCase(formik.values.id)}
                    open={removeCasePromptOpen}
                    onClose={() => setRemoveCasePromptOpen(false)}
                  />

                  <SimplePrompt
                    title="Sikker på at du vill slette denne linjen?"
                    description="Saken slettes permanent."
                    onAccept={() => removeCaseItem(selectedItem)}
                    open={removeCaseItemPromptOpen}
                    onClose={() => setRemoveCaseItemPromptOpen(false)}
                  />

                  {showCaseTypeDialog &&
                    createPortal(
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <div
                          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                          onClick={() => {
                            setCaseTypeSearch("");
                            setShowCaseTypeDialog(false);
                          }}
                          aria-hidden="true"
                        />
                        <div
                          className="relative w-full max-w-lg overflow-hidden rounded-[1.5rem] bg-white shadow-xl"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="border-b border-slate-200 px-5 py-4">
                            <div className="flex items-center justify-between gap-4">
                              <div>
                                <h3 className="text-base font-semibold text-slate-900">
                                  {t("Select case type")}
                                </h3>
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  setCaseTypeSearch("");
                                  setShowCaseTypeDialog(false);
                                }}
                                className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                              >
                                <XMarkIcon className="h-5 w-5" />
                              </button>
                            </div>
                            <div className="relative mt-4">
                              <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                              <input
                                type="text"
                                value={caseTypeSearch}
                                onChange={(e) => setCaseTypeSearch(e.target.value)}
                                placeholder={t("search")}
                                className="h-11 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm text-slate-700 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>

                          <div className="max-h-[26rem] overflow-y-auto px-3 py-3">
                            {caseTypeOptions.isLoading ? (
                              <div className="px-3 py-8 text-center text-sm text-slate-500">
                                {t("Loading...")}
                              </div>
                            ) : filteredCaseTypeOptions.length === 0 ? (
                              <div className="px-3 py-8 text-center text-sm text-slate-500">
                                {t("No results")}
                              </div>
                            ) : (
                              filteredCaseTypeOptions.map((opt) => {
                                const isSelected =
                                  String(formikRef.current?.values?.case_type_id) ===
                                  String(opt.value);
                                return (
                                  <button
                                    key={String(opt.value)}
                                    type="button"
                                    onClick={() => {
                                      if (formikRef.current) {
                                        formikRef.current.setFieldValue("case_type_id", opt.value);
                                        formikRef.current.setTouched({
                                          ...formikRef.current.touched,
                                          case_type_id: true,
                                        });
                                      }
                                      setCaseTypeSearch("");
                                      setShowCaseTypeDialog(false);
                                    }}
                                    className={`mb-2 flex w-full items-center justify-between rounded-2xl px-4 py-3 text-left text-sm transition ${
                                      isSelected
                                        ? "bg-blue-50 font-medium text-blue-800 ring-1 ring-blue-200"
                                        : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                                    }`}
                                  >
                                    <span>{opt.title ? t(String(opt.title)) : String(opt.value)}</span>
                                    {isSelected ? (
                                      <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700">
                                        {t("Selected")}
                                      </span>
                                    ) : null}
                                  </button>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}

                  {showPriorityDialog &&
                    createPortal(
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <div
                          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                          onClick={() => setShowPriorityDialog(false)}
                          aria-hidden="true"
                        />
                        <div
                          className="relative w-full max-w-md overflow-hidden rounded-[1.5rem] bg-white shadow-xl"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="border-b border-slate-200 px-5 py-4">
                            <div className="flex items-center justify-between gap-4">
                              <h3 className="text-base font-semibold text-slate-900">
                                {t("Select Priority")}
                              </h3>
                              <button
                                type="button"
                                onClick={() => setShowPriorityDialog(false)}
                                className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                              >
                                <XMarkIcon className="h-5 w-5" />
                              </button>
                            </div>
                          </div>
                          <div className="max-h-[24rem] space-y-2 overflow-y-auto px-3 py-3">
                            {priorityOptions.map((opt) => (
                              <button
                                key={opt.value}
                                type="button"
                                onClick={() => {
                                  if (!canEditCase) {
                                    presentCaseForbidden(
                                      "CASE_EDIT_FORBIDDEN",
                                      "cases.access.edit_forbidden"
                                    );
                                    setShowPriorityDialog(false);
                                    return;
                                  }
                                  if (formikRef.current) {
                                    formikRef.current.setFieldValue("priority", opt.value);
                                    formikRef.current.setTouched({
                                      ...formikRef.current.touched,
                                      priority: true,
                                    });
                                  }
                                  setShowPriorityDialog(false);
                                }}
                                className={`w-full rounded-2xl px-4 py-3 text-left text-sm font-medium transition-colors ${
                                  String(formikRef.current?.values?.priority) === String(opt.value)
                                    ? `${opt.class} ring-1 ring-slate-200`
                                    : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                                }`}
                              >
                                {t(String(opt.label))}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}

                  {showStatusDialog &&
                    createPortal(
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <div
                          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                          onClick={() => setShowStatusDialog(false)}
                          aria-hidden="true"
                        />
                        <div
                          className="relative w-full max-w-md overflow-hidden rounded-[1.5rem] bg-white shadow-xl"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="border-b border-slate-200 px-5 py-4">
                            <div className="flex items-center justify-between gap-4">
                              <h3 className="text-base font-semibold text-slate-900">
                                {t("Select status")}
                              </h3>
                              <button
                                type="button"
                                onClick={() => setShowStatusDialog(false)}
                                className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                              >
                                <XMarkIcon className="h-5 w-5" />
                              </button>
                            </div>
                          </div>
                          <div className="max-h-[24rem] space-y-2 overflow-y-auto px-3 py-3">
                            {statusOptions.map((opt) => {
                              const isSelected =
                                String(
                                  formikRef.current?.values?.status || caseItem?.status || ""
                                ).toUpperCase() === opt.value;
                              return (
                                <button
                                  key={opt.value}
                                  type="button"
                                  onClick={async () => {
                                    if (!canEditCase) {
                                      presentCaseForbidden(
                                        "CASE_EDIT_FORBIDDEN",
                                        "cases.access.edit_forbidden"
                                      );
                                      setShowStatusDialog(false);
                                      return;
                                    }
                                    if (formikRef.current) {
                                      await formikRef.current.setFieldValue("status", opt.value);
                                      formikRef.current.setTouched({
                                        ...formikRef.current.touched,
                                        status: true,
                                      });
                                      if (caseItem?.id) {
                                        await formikRef.current.submitForm();
                                      }
                                    }
                                    setShowStatusDialog(false);
                                  }}
                                  className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-sm font-medium transition-colors ${
                                    isSelected
                                      ? `${opt.class} ring-1 ring-slate-200`
                                      : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                                  }`}
                                >
                                  <span
                                    className="cv-prio-dot"
                                    style={{ background: opt.dot }}
                                  />
                                  <span className="flex-1">{opt.label}</span>
                                  {isSelected ? (
                                    <span className="rounded-full bg-white/70 px-2 py-1 text-xs font-medium">
                                      {t("Selected")}
                                    </span>
                                  ) : null}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}
                </>
              );
              }}
            </Formik>
        </div>
      )}

      <ServiceReportEditModal
        module="case"
        module_param=""
        customer={caseItem?.customer}
        project={caseItem?.project}
        fields={caseItemFields}
        open={reportDialogOpen}
        onClose={() => setReportDialogOpen(false)}
        selected={caseItem?.report?.id ? caseItem?.report : null}
        onRefresh={(data) => onUpdateModuleChange("report", data)}
        onCreated={(data) => onUpdateModuleChange("report", data).unwrap()}
      />

      <CustomerDialog
        open={customerDialogOpen}
        onClose={() => setCustomerDialogOpen(false)}
        readOnly={true}
        // selected={{ report.customer }}
        // Only for testing
        selected={caseItem?.customer}
        onRefresh={() => getCase()}
      />

      <ServiceAgreementModal
        open={serviceAgreementDialogOpen}
        onClose={() => {
          setServiceAgreementDialogOpen(false);
        }}
        customer={caseItem?.customer}
        project={caseItem?.project}
        fields={caseItemFields}
        onRefresh={(data) => {
          onUpdateModuleChange("service_agreement", data);
        }}
        selected={
          caseItem?.service_agreement?.id ? caseItem?.service_agreement : null
        }
      />

      <SimplePrompt
        title={t("case.finish_after_prompt")}
        description=""
        onAccept={() => handleFinishQuestion(true)}
        open={finishQuestionPromptOpen}
        onClose={() => handleFinishQuestion(false)}
      />

      <FieldDialog
        open={fieldDialogOpen}
        onClose={() => setFieldDialogOpen(false)}
        module="case"
        moduleParam={caseItem?.id}
      />

      <CustomerSystemDialog
        open={systemDialogOpen}
        onClose={() => setSystemDialogOpen(false)}
        customer={caseItem?.customer}
        selected={null}
        caseId={caseItem?.id}
        onAttachSystem={({ value }) => {
          if (!value || !caseItem?.id || !caseItem?.customer?.id) return;
          updateSystem({
            id: value,
            customer_id: caseItem.customer.id,
            case_id: caseItem.id,
          }).then(() => loadCaseSystems());
        }}
        onRefresh={() => {
          loadCaseSystems();
          setSystemDialogOpen(false);
        }}
      />

      <GuideTemplatePickerDialog
        open={guidePickerState.open}
        templates={guidePickerState.templates}
        purpose={guidePickerState.purpose}
        onClose={() => setGuidePickerState((prev) => ({ ...prev, open: false }))}
        onSelect={(template) => {
          setGuidePickerState((prev) => ({ ...prev, open: false }));
          openGuideTemplate(template, guidePickerState.purpose);
        }}
      />

      <CaseGuideOnboardingDialog
        open={caseGuideState.open}
        template={caseGuideState.template}
        purpose={caseGuideState.purpose}
        onClose={() => setCaseGuideState((prev) => ({ ...prev, open: false }))}
        onComplete={handleGuideComplete}
      />

      <CaseCreateOnboardingDialog
        open={createCaseDialogOpen}
        onClose={() => setCreateCaseDialogOpen(false)}
      />
    </>
  );
}
